export const profile = {
  customTitle: null,
  data: [
    {
      name: "",
      email: "",
      phone: null,
      jobTitle: null,
      city: null,
      website: null,
      photo: null,
      showFields: {
        jobTitle: true,
        phone: true,
        website: true,
        email: true,
        city: true,
        photo: true,
        upperCaseName: true,
      },
    },
  ],
};
export const Countries = [
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "AD",
    COUNTRY_ALPHA3_CODE: "AND",
    COUNTRY_NUMERIC_CODE: 20,
    COUNTRY_NAME: "Andorra",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "AE",
    COUNTRY_ALPHA3_CODE: "ARE",
    COUNTRY_NUMERIC_CODE: 784,
    COUNTRY_NAME: "United Arab Emirates",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "AF",
    COUNTRY_ALPHA3_CODE: "AFG",
    COUNTRY_NUMERIC_CODE: 4,
    COUNTRY_NAME: "Afghanistan",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "AG",
    COUNTRY_ALPHA3_CODE: "ATG",
    COUNTRY_NUMERIC_CODE: 28,
    COUNTRY_NAME: "Antigua and Barbuda",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "AI",
    COUNTRY_ALPHA3_CODE: "AIA",
    COUNTRY_NUMERIC_CODE: 660,
    COUNTRY_NAME: "Anguilla",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "AL",
    COUNTRY_ALPHA3_CODE: "ALB",
    COUNTRY_NUMERIC_CODE: 8,
    COUNTRY_NAME: "Albania",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "AM",
    COUNTRY_ALPHA3_CODE: "ARM",
    COUNTRY_NUMERIC_CODE: 51,
    COUNTRY_NAME: "Armenia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "AO",
    COUNTRY_ALPHA3_CODE: "AGO",
    COUNTRY_NUMERIC_CODE: 24,
    COUNTRY_NAME: "Angola",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "AQ",
    COUNTRY_ALPHA3_CODE: "ATA",
    COUNTRY_NUMERIC_CODE: 10,
    COUNTRY_NAME: "Antarctica",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "AR",
    COUNTRY_ALPHA3_CODE: "ARG",
    COUNTRY_NUMERIC_CODE: 32,
    COUNTRY_NAME: "Argentina",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "AS",
    COUNTRY_ALPHA3_CODE: "ASM",
    COUNTRY_NUMERIC_CODE: 16,
    COUNTRY_NAME: "American Samoa",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "AT",
    COUNTRY_ALPHA3_CODE: "AUT",
    COUNTRY_NUMERIC_CODE: 40,
    COUNTRY_NAME: "Austria",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "AU",
    COUNTRY_ALPHA3_CODE: "AUS",
    COUNTRY_NUMERIC_CODE: 36,
    COUNTRY_NAME: "Australia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "AW",
    COUNTRY_ALPHA3_CODE: "ABW",
    COUNTRY_NUMERIC_CODE: 533,
    COUNTRY_NAME: "Aruba",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "AX",
    COUNTRY_ALPHA3_CODE: "ALA",
    COUNTRY_NUMERIC_CODE: 248,
    COUNTRY_NAME: "Aland Islands",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "AZ",
    COUNTRY_ALPHA3_CODE: "AZE",
    COUNTRY_NUMERIC_CODE: 31,
    COUNTRY_NAME: "Azerbaijan",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BA",
    COUNTRY_ALPHA3_CODE: "BIH",
    COUNTRY_NUMERIC_CODE: 70,
    COUNTRY_NAME: "Bosnia and Herzegovina",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BB",
    COUNTRY_ALPHA3_CODE: "BRB",
    COUNTRY_NUMERIC_CODE: 52,
    COUNTRY_NAME: "Barbados",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BD",
    COUNTRY_ALPHA3_CODE: "BGD",
    COUNTRY_NUMERIC_CODE: 50,
    COUNTRY_NAME: "Bangladesh",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BE",
    COUNTRY_ALPHA3_CODE: "BEL",
    COUNTRY_NUMERIC_CODE: 56,
    COUNTRY_NAME: "Belgium",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BF",
    COUNTRY_ALPHA3_CODE: "BFA",
    COUNTRY_NUMERIC_CODE: 854,
    COUNTRY_NAME: "Burkina Faso",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BG",
    COUNTRY_ALPHA3_CODE: "BGR",
    COUNTRY_NUMERIC_CODE: 100,
    COUNTRY_NAME: "Bulgaria",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BH",
    COUNTRY_ALPHA3_CODE: "BHR",
    COUNTRY_NUMERIC_CODE: 48,
    COUNTRY_NAME: "Bahrain",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BI",
    COUNTRY_ALPHA3_CODE: "BDI",
    COUNTRY_NUMERIC_CODE: 108,
    COUNTRY_NAME: "Burundi",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BJ",
    COUNTRY_ALPHA3_CODE: "BEN",
    COUNTRY_NUMERIC_CODE: 204,
    COUNTRY_NAME: "Benin",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BL",
    COUNTRY_ALPHA3_CODE: "BLM",
    COUNTRY_NUMERIC_CODE: 652,
    COUNTRY_NAME: "Saint Barthelemy",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BM",
    COUNTRY_ALPHA3_CODE: "BMU",
    COUNTRY_NUMERIC_CODE: 60,
    COUNTRY_NAME: "Bermuda",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BN",
    COUNTRY_ALPHA3_CODE: "BRN",
    COUNTRY_NUMERIC_CODE: 96,
    COUNTRY_NAME: "Brunei Darussalam",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BO",
    COUNTRY_ALPHA3_CODE: "BOL",
    COUNTRY_NUMERIC_CODE: 68,
    COUNTRY_NAME: "Bolivia (Plurinational State of)",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BQ",
    COUNTRY_ALPHA3_CODE: "BES",
    COUNTRY_NUMERIC_CODE: 535,
    COUNTRY_NAME: "Bonaire, Sint Eustatius and Saba",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BR",
    COUNTRY_ALPHA3_CODE: "BRA",
    COUNTRY_NUMERIC_CODE: 76,
    COUNTRY_NAME: "Brazil",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BS",
    COUNTRY_ALPHA3_CODE: "BHS",
    COUNTRY_NUMERIC_CODE: 44,
    COUNTRY_NAME: "Bahamas",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BT",
    COUNTRY_ALPHA3_CODE: "BTN",
    COUNTRY_NUMERIC_CODE: 64,
    COUNTRY_NAME: "Bhutan",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BV",
    COUNTRY_ALPHA3_CODE: "BVT",
    COUNTRY_NUMERIC_CODE: 74,
    COUNTRY_NAME: "Bouvet Island",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BW",
    COUNTRY_ALPHA3_CODE: "BWA",
    COUNTRY_NUMERIC_CODE: 72,
    COUNTRY_NAME: "Botswana",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BY",
    COUNTRY_ALPHA3_CODE: "BLR",
    COUNTRY_NUMERIC_CODE: 112,
    COUNTRY_NAME: "Belarus",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "BZ",
    COUNTRY_ALPHA3_CODE: "BLZ",
    COUNTRY_NUMERIC_CODE: 84,
    COUNTRY_NAME: "Belize",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "CA",
    COUNTRY_ALPHA3_CODE: "CAN",
    COUNTRY_NUMERIC_CODE: 124,
    COUNTRY_NAME: "Canada",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "CC",
    COUNTRY_ALPHA3_CODE: "CCK",
    COUNTRY_NUMERIC_CODE: 166,
    COUNTRY_NAME: "Cocos (Keeling) Islands",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "CD",
    COUNTRY_ALPHA3_CODE: "COD",
    COUNTRY_NUMERIC_CODE: 180,
    COUNTRY_NAME: "Congo (Democratic Republic of the)",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "CF",
    COUNTRY_ALPHA3_CODE: "CAF",
    COUNTRY_NUMERIC_CODE: 140,
    COUNTRY_NAME: "Central African Republic",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "CG",
    COUNTRY_ALPHA3_CODE: "COG",
    COUNTRY_NUMERIC_CODE: 178,
    COUNTRY_NAME: "Congo",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "CH",
    COUNTRY_ALPHA3_CODE: "CHE",
    COUNTRY_NUMERIC_CODE: 756,
    COUNTRY_NAME: "Switzerland",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "CI",
    COUNTRY_ALPHA3_CODE: "CIV",
    COUNTRY_NUMERIC_CODE: 384,
    COUNTRY_NAME: "Cote d'Ivoire",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "CK",
    COUNTRY_ALPHA3_CODE: "COK",
    COUNTRY_NUMERIC_CODE: 184,
    COUNTRY_NAME: "Cook Islands",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "CL",
    COUNTRY_ALPHA3_CODE: "CHL",
    COUNTRY_NUMERIC_CODE: 152,
    COUNTRY_NAME: "Chile",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "CM",
    COUNTRY_ALPHA3_CODE: "CMR",
    COUNTRY_NUMERIC_CODE: 120,
    COUNTRY_NAME: "Cameroon",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "CN",
    COUNTRY_ALPHA3_CODE: "CHN",
    COUNTRY_NUMERIC_CODE: 156,
    COUNTRY_NAME: "China",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "CO",
    COUNTRY_ALPHA3_CODE: "COL",
    COUNTRY_NUMERIC_CODE: 170,
    COUNTRY_NAME: "Colombia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "CR",
    COUNTRY_ALPHA3_CODE: "CRI",
    COUNTRY_NUMERIC_CODE: 188,
    COUNTRY_NAME: "Costa Rica",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "CU",
    COUNTRY_ALPHA3_CODE: "CUB",
    COUNTRY_NUMERIC_CODE: 192,
    COUNTRY_NAME: "Cuba",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "CV",
    COUNTRY_ALPHA3_CODE: "CPV",
    COUNTRY_NUMERIC_CODE: 132,
    COUNTRY_NAME: "Cabo Verde",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "CW",
    COUNTRY_ALPHA3_CODE: "CUW",
    COUNTRY_NUMERIC_CODE: 531,
    COUNTRY_NAME: "Curaçao",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "CX",
    COUNTRY_ALPHA3_CODE: "CXR",
    COUNTRY_NUMERIC_CODE: 162,
    COUNTRY_NAME: "Christmas Island",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "CY",
    COUNTRY_ALPHA3_CODE: "CYP",
    COUNTRY_NUMERIC_CODE: 196,
    COUNTRY_NAME: "Cyprus",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "CZ",
    COUNTRY_ALPHA3_CODE: "CZE",
    COUNTRY_NUMERIC_CODE: 203,
    COUNTRY_NAME: "Czechia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "DE",
    COUNTRY_ALPHA3_CODE: "DEU",
    COUNTRY_NUMERIC_CODE: 276,
    COUNTRY_NAME: "Germany",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "DJ",
    COUNTRY_ALPHA3_CODE: "DJI",
    COUNTRY_NUMERIC_CODE: 262,
    COUNTRY_NAME: "Djibouti",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "DK",
    COUNTRY_ALPHA3_CODE: "DNK",
    COUNTRY_NUMERIC_CODE: 208,
    COUNTRY_NAME: "Denmark",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "DM",
    COUNTRY_ALPHA3_CODE: "DMA",
    COUNTRY_NUMERIC_CODE: 212,
    COUNTRY_NAME: "Dominica",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "DO",
    COUNTRY_ALPHA3_CODE: "DOM",
    COUNTRY_NUMERIC_CODE: 214,
    COUNTRY_NAME: "Dominican Republic",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "DZ",
    COUNTRY_ALPHA3_CODE: "DZA",
    COUNTRY_NUMERIC_CODE: 12,
    COUNTRY_NAME: "Algeria",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "EC",
    COUNTRY_ALPHA3_CODE: "ECU",
    COUNTRY_NUMERIC_CODE: 218,
    COUNTRY_NAME: "Ecuador",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "EE",
    COUNTRY_ALPHA3_CODE: "EST",
    COUNTRY_NUMERIC_CODE: 233,
    COUNTRY_NAME: "Estonia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "EG",
    COUNTRY_ALPHA3_CODE: "EGY",
    COUNTRY_NUMERIC_CODE: 818,
    COUNTRY_NAME: "Egypt",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "EH",
    COUNTRY_ALPHA3_CODE: "ESH",
    COUNTRY_NUMERIC_CODE: 732,
    COUNTRY_NAME: "Western Sahara",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "ER",
    COUNTRY_ALPHA3_CODE: "ERI",
    COUNTRY_NUMERIC_CODE: 232,
    COUNTRY_NAME: "Eritrea",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "ES",
    COUNTRY_ALPHA3_CODE: "ESP",
    COUNTRY_NUMERIC_CODE: 724,
    COUNTRY_NAME: "Spain",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "ET",
    COUNTRY_ALPHA3_CODE: "ETH",
    COUNTRY_NUMERIC_CODE: 231,
    COUNTRY_NAME: "Ethiopia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "FI",
    COUNTRY_ALPHA3_CODE: "FIN",
    COUNTRY_NUMERIC_CODE: 246,
    COUNTRY_NAME: "Finland",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "FJ",
    COUNTRY_ALPHA3_CODE: "FJI",
    COUNTRY_NUMERIC_CODE: 242,
    COUNTRY_NAME: "Fiji",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "FK",
    COUNTRY_ALPHA3_CODE: "FLK",
    COUNTRY_NUMERIC_CODE: 238,
    COUNTRY_NAME: "Falkland Islands (Malvinas)",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "FM",
    COUNTRY_ALPHA3_CODE: "FSM",
    COUNTRY_NUMERIC_CODE: 583,
    COUNTRY_NAME: "Micronesia (Federated States of)",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "FO",
    COUNTRY_ALPHA3_CODE: "FRO",
    COUNTRY_NUMERIC_CODE: 234,
    COUNTRY_NAME: "Faroe Islands",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "FR",
    COUNTRY_ALPHA3_CODE: "FRA",
    COUNTRY_NUMERIC_CODE: 250,
    COUNTRY_NAME: "France",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "GA",
    COUNTRY_ALPHA3_CODE: "GAB",
    COUNTRY_NUMERIC_CODE: 266,
    COUNTRY_NAME: "Gabon",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "GB",
    COUNTRY_ALPHA3_CODE: "GBR",
    COUNTRY_NUMERIC_CODE: 826,
    COUNTRY_NAME: "United Kingdom of Great Britain and Northern Ireland",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "GD",
    COUNTRY_ALPHA3_CODE: "GRD",
    COUNTRY_NUMERIC_CODE: 308,
    COUNTRY_NAME: "Grenada",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "GE",
    COUNTRY_ALPHA3_CODE: "GEO",
    COUNTRY_NUMERIC_CODE: 268,
    COUNTRY_NAME: "Georgia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "GF",
    COUNTRY_ALPHA3_CODE: "GUF",
    COUNTRY_NUMERIC_CODE: 254,
    COUNTRY_NAME: "French Guiana",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "GG",
    COUNTRY_ALPHA3_CODE: "GGY",
    COUNTRY_NUMERIC_CODE: 831,
    COUNTRY_NAME: "Guernsey",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "GH",
    COUNTRY_ALPHA3_CODE: "GHA",
    COUNTRY_NUMERIC_CODE: 288,
    COUNTRY_NAME: "Ghana",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "GI",
    COUNTRY_ALPHA3_CODE: "GIB",
    COUNTRY_NUMERIC_CODE: 292,
    COUNTRY_NAME: "Gibraltar",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "GL",
    COUNTRY_ALPHA3_CODE: "GRL",
    COUNTRY_NUMERIC_CODE: 304,
    COUNTRY_NAME: "Greenland",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "GM",
    COUNTRY_ALPHA3_CODE: "GMB",
    COUNTRY_NUMERIC_CODE: 270,
    COUNTRY_NAME: "Gambia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "GN",
    COUNTRY_ALPHA3_CODE: "GIN",
    COUNTRY_NUMERIC_CODE: 324,
    COUNTRY_NAME: "Guinea",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "GP",
    COUNTRY_ALPHA3_CODE: "GLP",
    COUNTRY_NUMERIC_CODE: 312,
    COUNTRY_NAME: "Guadeloupe",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "GQ",
    COUNTRY_ALPHA3_CODE: "GNQ",
    COUNTRY_NUMERIC_CODE: 226,
    COUNTRY_NAME: "Equatorial Guinea",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "GR",
    COUNTRY_ALPHA3_CODE: "GRC",
    COUNTRY_NUMERIC_CODE: 300,
    COUNTRY_NAME: "Greece",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "GS",
    COUNTRY_ALPHA3_CODE: "SGS",
    COUNTRY_NUMERIC_CODE: 239,
    COUNTRY_NAME: "South Georgia and the South Sandwich Islands",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "GT",
    COUNTRY_ALPHA3_CODE: "GTM",
    COUNTRY_NUMERIC_CODE: 320,
    COUNTRY_NAME: "Guatemala",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "GU",
    COUNTRY_ALPHA3_CODE: "GUM",
    COUNTRY_NUMERIC_CODE: 316,
    COUNTRY_NAME: "Guam",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "GW",
    COUNTRY_ALPHA3_CODE: "GNB",
    COUNTRY_NUMERIC_CODE: 624,
    COUNTRY_NAME: "Guinea-Bissau",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "GY",
    COUNTRY_ALPHA3_CODE: "GUY",
    COUNTRY_NUMERIC_CODE: 328,
    COUNTRY_NAME: "Guyana",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "HK",
    COUNTRY_ALPHA3_CODE: "HKG",
    COUNTRY_NUMERIC_CODE: 344,
    COUNTRY_NAME: "Hong Kong",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "HM",
    COUNTRY_ALPHA3_CODE: "HMD",
    COUNTRY_NUMERIC_CODE: 334,
    COUNTRY_NAME: "Heard Island and McDonald Islands",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "HN",
    COUNTRY_ALPHA3_CODE: "HND",
    COUNTRY_NUMERIC_CODE: 340,
    COUNTRY_NAME: "Honduras",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "HR",
    COUNTRY_ALPHA3_CODE: "HRV",
    COUNTRY_NUMERIC_CODE: 191,
    COUNTRY_NAME: "Croatia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "HT",
    COUNTRY_ALPHA3_CODE: "HTI",
    COUNTRY_NUMERIC_CODE: 332,
    COUNTRY_NAME: "Haiti",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "HU",
    COUNTRY_ALPHA3_CODE: "HUN",
    COUNTRY_NUMERIC_CODE: 348,
    COUNTRY_NAME: "Hungary",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "ID",
    COUNTRY_ALPHA3_CODE: "IDN",
    COUNTRY_NUMERIC_CODE: 360,
    COUNTRY_NAME: "Indonesia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "IE",
    COUNTRY_ALPHA3_CODE: "IRL",
    COUNTRY_NUMERIC_CODE: 372,
    COUNTRY_NAME: "Ireland",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "IL",
    COUNTRY_ALPHA3_CODE: "ISR",
    COUNTRY_NUMERIC_CODE: 376,
    COUNTRY_NAME: "Israel",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "IM",
    COUNTRY_ALPHA3_CODE: "IMN",
    COUNTRY_NUMERIC_CODE: 833,
    COUNTRY_NAME: "Isle of Man",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "IN",
    COUNTRY_ALPHA3_CODE: "IND",
    COUNTRY_NUMERIC_CODE: 356,
    COUNTRY_NAME: "India",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "IO",
    COUNTRY_ALPHA3_CODE: "IOT",
    COUNTRY_NUMERIC_CODE: 86,
    COUNTRY_NAME: "British Indian Ocean Territory",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "IQ",
    COUNTRY_ALPHA3_CODE: "IRQ",
    COUNTRY_NUMERIC_CODE: 368,
    COUNTRY_NAME: "Iraq",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "IR",
    COUNTRY_ALPHA3_CODE: "IRN",
    COUNTRY_NUMERIC_CODE: 364,
    COUNTRY_NAME: "Iran (Islamic Republic of)",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "IS",
    COUNTRY_ALPHA3_CODE: "ISL",
    COUNTRY_NUMERIC_CODE: 352,
    COUNTRY_NAME: "Iceland",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "IT",
    COUNTRY_ALPHA3_CODE: "ITA",
    COUNTRY_NUMERIC_CODE: 380,
    COUNTRY_NAME: "Italy",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "JE",
    COUNTRY_ALPHA3_CODE: "JEY",
    COUNTRY_NUMERIC_CODE: 832,
    COUNTRY_NAME: "Jersey",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "JM",
    COUNTRY_ALPHA3_CODE: "JAM",
    COUNTRY_NUMERIC_CODE: 388,
    COUNTRY_NAME: "Jamaica",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "JO",
    COUNTRY_ALPHA3_CODE: "JOR",
    COUNTRY_NUMERIC_CODE: 400,
    COUNTRY_NAME: "Jordan",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "JP",
    COUNTRY_ALPHA3_CODE: "JPN",
    COUNTRY_NUMERIC_CODE: 392,
    COUNTRY_NAME: "Japan",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "KE",
    COUNTRY_ALPHA3_CODE: "KEN",
    COUNTRY_NUMERIC_CODE: 404,
    COUNTRY_NAME: "Kenya",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "KG",
    COUNTRY_ALPHA3_CODE: "KGZ",
    COUNTRY_NUMERIC_CODE: 417,
    COUNTRY_NAME: "Kyrgyzstan",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "KH",
    COUNTRY_ALPHA3_CODE: "KHM",
    COUNTRY_NUMERIC_CODE: 116,
    COUNTRY_NAME: "Cambodia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "KI",
    COUNTRY_ALPHA3_CODE: "KIR",
    COUNTRY_NUMERIC_CODE: 296,
    COUNTRY_NAME: "Kiribati",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "KM",
    COUNTRY_ALPHA3_CODE: "COM",
    COUNTRY_NUMERIC_CODE: 174,
    COUNTRY_NAME: "Comoros",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "KN",
    COUNTRY_ALPHA3_CODE: "KNA",
    COUNTRY_NUMERIC_CODE: 659,
    COUNTRY_NAME: "Saint Kitts and Nevis",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "KP",
    COUNTRY_ALPHA3_CODE: "PRK",
    COUNTRY_NUMERIC_CODE: 408,
    COUNTRY_NAME: "Korea (Democratic People's Republic of)",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "KR",
    COUNTRY_ALPHA3_CODE: "KOR",
    COUNTRY_NUMERIC_CODE: 410,
    COUNTRY_NAME: "Korea (Republic of)",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "KW",
    COUNTRY_ALPHA3_CODE: "KWT",
    COUNTRY_NUMERIC_CODE: 414,
    COUNTRY_NAME: "Kuwait",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "KY",
    COUNTRY_ALPHA3_CODE: "CYM",
    COUNTRY_NUMERIC_CODE: 136,
    COUNTRY_NAME: "Cayman Islands",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "KZ",
    COUNTRY_ALPHA3_CODE: "KAZ",
    COUNTRY_NUMERIC_CODE: 398,
    COUNTRY_NAME: "Kazakhstan",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "LA",
    COUNTRY_ALPHA3_CODE: "LAO",
    COUNTRY_NUMERIC_CODE: 418,
    COUNTRY_NAME: "Lao People's Democratic Republic",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "LB",
    COUNTRY_ALPHA3_CODE: "LBN",
    COUNTRY_NUMERIC_CODE: 422,
    COUNTRY_NAME: "Lebanon",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "LC",
    COUNTRY_ALPHA3_CODE: "LCA",
    COUNTRY_NUMERIC_CODE: 662,
    COUNTRY_NAME: "Saint Lucia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "LI",
    COUNTRY_ALPHA3_CODE: "LIE",
    COUNTRY_NUMERIC_CODE: 438,
    COUNTRY_NAME: "Liechtenstein",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "LK",
    COUNTRY_ALPHA3_CODE: "LKA",
    COUNTRY_NUMERIC_CODE: 144,
    COUNTRY_NAME: "Sri Lanka",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "LR",
    COUNTRY_ALPHA3_CODE: "LBR",
    COUNTRY_NUMERIC_CODE: 430,
    COUNTRY_NAME: "Liberia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "LS",
    COUNTRY_ALPHA3_CODE: "LSO",
    COUNTRY_NUMERIC_CODE: 426,
    COUNTRY_NAME: "Lesotho",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "LT",
    COUNTRY_ALPHA3_CODE: "LTU",
    COUNTRY_NUMERIC_CODE: 440,
    COUNTRY_NAME: "Lithuania",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "LU",
    COUNTRY_ALPHA3_CODE: "LUX",
    COUNTRY_NUMERIC_CODE: 442,
    COUNTRY_NAME: "Luxembourg",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "LV",
    COUNTRY_ALPHA3_CODE: "LVA",
    COUNTRY_NUMERIC_CODE: 428,
    COUNTRY_NAME: "Latvia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "LY",
    COUNTRY_ALPHA3_CODE: "LBY",
    COUNTRY_NUMERIC_CODE: 434,
    COUNTRY_NAME: "Libya",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MA",
    COUNTRY_ALPHA3_CODE: "MAR",
    COUNTRY_NUMERIC_CODE: 504,
    COUNTRY_NAME: "Morocco",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MC",
    COUNTRY_ALPHA3_CODE: "MCO",
    COUNTRY_NUMERIC_CODE: 492,
    COUNTRY_NAME: "Monaco",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MD",
    COUNTRY_ALPHA3_CODE: "MDA",
    COUNTRY_NUMERIC_CODE: 498,
    COUNTRY_NAME: "Moldova (Republic of)",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "ME",
    COUNTRY_ALPHA3_CODE: "MNE",
    COUNTRY_NUMERIC_CODE: 499,
    COUNTRY_NAME: "Montenegro",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MF",
    COUNTRY_ALPHA3_CODE: "MAF",
    COUNTRY_NUMERIC_CODE: 663,
    COUNTRY_NAME: "Saint Martin (French Part)",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MG",
    COUNTRY_ALPHA3_CODE: "MDG",
    COUNTRY_NUMERIC_CODE: 450,
    COUNTRY_NAME: "Madagascar",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MH",
    COUNTRY_ALPHA3_CODE: "MHL",
    COUNTRY_NUMERIC_CODE: 584,
    COUNTRY_NAME: "Marshall Islands",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MK",
    COUNTRY_ALPHA3_CODE: "MKD",
    COUNTRY_NUMERIC_CODE: 807,
    COUNTRY_NAME: "North Macedonia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "ML",
    COUNTRY_ALPHA3_CODE: "MLI",
    COUNTRY_NUMERIC_CODE: 466,
    COUNTRY_NAME: "Mali",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MM",
    COUNTRY_ALPHA3_CODE: "MMR",
    COUNTRY_NUMERIC_CODE: 104,
    COUNTRY_NAME: "Myanmar",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MN",
    COUNTRY_ALPHA3_CODE: "MNG",
    COUNTRY_NUMERIC_CODE: 496,
    COUNTRY_NAME: "Mongolia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MO",
    COUNTRY_ALPHA3_CODE: "MAC",
    COUNTRY_NUMERIC_CODE: 446,
    COUNTRY_NAME: "Macao",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MP",
    COUNTRY_ALPHA3_CODE: "MNP",
    COUNTRY_NUMERIC_CODE: 580,
    COUNTRY_NAME: "Northern Mariana Islands",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MQ",
    COUNTRY_ALPHA3_CODE: "MTQ",
    COUNTRY_NUMERIC_CODE: 474,
    COUNTRY_NAME: "Martinique",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MR",
    COUNTRY_ALPHA3_CODE: "MRT",
    COUNTRY_NUMERIC_CODE: 478,
    COUNTRY_NAME: "Mauritania",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MS",
    COUNTRY_ALPHA3_CODE: "MSR",
    COUNTRY_NUMERIC_CODE: 500,
    COUNTRY_NAME: "Montserrat",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MT",
    COUNTRY_ALPHA3_CODE: "MLT",
    COUNTRY_NUMERIC_CODE: 470,
    COUNTRY_NAME: "Malta",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MU",
    COUNTRY_ALPHA3_CODE: "MUS",
    COUNTRY_NUMERIC_CODE: 480,
    COUNTRY_NAME: "Mauritius",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MV",
    COUNTRY_ALPHA3_CODE: "MDV",
    COUNTRY_NUMERIC_CODE: 462,
    COUNTRY_NAME: "Maldives",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MW",
    COUNTRY_ALPHA3_CODE: "MWI",
    COUNTRY_NUMERIC_CODE: 454,
    COUNTRY_NAME: "Malawi",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MX",
    COUNTRY_ALPHA3_CODE: "MEX",
    COUNTRY_NUMERIC_CODE: 484,
    COUNTRY_NAME: "Mexico",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MY",
    COUNTRY_ALPHA3_CODE: "MYS",
    COUNTRY_NUMERIC_CODE: 458,
    COUNTRY_NAME: "Malaysia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "MZ",
    COUNTRY_ALPHA3_CODE: "MOZ",
    COUNTRY_NUMERIC_CODE: 508,
    COUNTRY_NAME: "Mozambique",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "NA",
    COUNTRY_ALPHA3_CODE: "NAM",
    COUNTRY_NUMERIC_CODE: 516,
    COUNTRY_NAME: "Namibia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "NC",
    COUNTRY_ALPHA3_CODE: "NCL",
    COUNTRY_NUMERIC_CODE: 540,
    COUNTRY_NAME: "New Caledonia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "NE",
    COUNTRY_ALPHA3_CODE: "NER",
    COUNTRY_NUMERIC_CODE: 562,
    COUNTRY_NAME: "Niger",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "NF",
    COUNTRY_ALPHA3_CODE: "NFK",
    COUNTRY_NUMERIC_CODE: 574,
    COUNTRY_NAME: "Norfolk Island",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "NG",
    COUNTRY_ALPHA3_CODE: "NGA",
    COUNTRY_NUMERIC_CODE: 566,
    COUNTRY_NAME: "Nigeria",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "NI",
    COUNTRY_ALPHA3_CODE: "NIC",
    COUNTRY_NUMERIC_CODE: 558,
    COUNTRY_NAME: "Nicaragua",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "NL",
    COUNTRY_ALPHA3_CODE: "NLD",
    COUNTRY_NUMERIC_CODE: 528,
    COUNTRY_NAME: "Netherlands",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "NO",
    COUNTRY_ALPHA3_CODE: "NOR",
    COUNTRY_NUMERIC_CODE: 578,
    COUNTRY_NAME: "Norway",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "NP",
    COUNTRY_ALPHA3_CODE: "NPL",
    COUNTRY_NUMERIC_CODE: 524,
    COUNTRY_NAME: "Nepal",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "NR",
    COUNTRY_ALPHA3_CODE: "NRU",
    COUNTRY_NUMERIC_CODE: 520,
    COUNTRY_NAME: "Nauru",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "NU",
    COUNTRY_ALPHA3_CODE: "NIU",
    COUNTRY_NUMERIC_CODE: 570,
    COUNTRY_NAME: "Niue",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "NZ",
    COUNTRY_ALPHA3_CODE: "NZL",
    COUNTRY_NUMERIC_CODE: 554,
    COUNTRY_NAME: "New Zealand",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "OM",
    COUNTRY_ALPHA3_CODE: "OMN",
    COUNTRY_NUMERIC_CODE: 512,
    COUNTRY_NAME: "Oman",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "PA",
    COUNTRY_ALPHA3_CODE: "PAN",
    COUNTRY_NUMERIC_CODE: 591,
    COUNTRY_NAME: "Panama",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "PE",
    COUNTRY_ALPHA3_CODE: "PER",
    COUNTRY_NUMERIC_CODE: 604,
    COUNTRY_NAME: "Peru",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "PF",
    COUNTRY_ALPHA3_CODE: "PYF",
    COUNTRY_NUMERIC_CODE: 258,
    COUNTRY_NAME: "French Polynesia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "PG",
    COUNTRY_ALPHA3_CODE: "PNG",
    COUNTRY_NUMERIC_CODE: 598,
    COUNTRY_NAME: "Papua New Guinea",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "PH",
    COUNTRY_ALPHA3_CODE: "PHL",
    COUNTRY_NUMERIC_CODE: 608,
    COUNTRY_NAME: "Philippines",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "PK",
    COUNTRY_ALPHA3_CODE: "PAK",
    COUNTRY_NUMERIC_CODE: 586,
    COUNTRY_NAME: "Pakistan",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "PL",
    COUNTRY_ALPHA3_CODE: "POL",
    COUNTRY_NUMERIC_CODE: 616,
    COUNTRY_NAME: "Poland",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "PM",
    COUNTRY_ALPHA3_CODE: "SPM",
    COUNTRY_NUMERIC_CODE: 666,
    COUNTRY_NAME: "Saint Pierre and Miquelon",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "PN",
    COUNTRY_ALPHA3_CODE: "PCN",
    COUNTRY_NUMERIC_CODE: 612,
    COUNTRY_NAME: "Pitcairn",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "PR",
    COUNTRY_ALPHA3_CODE: "PRI",
    COUNTRY_NUMERIC_CODE: 630,
    COUNTRY_NAME: "Puerto Rico",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "PS",
    COUNTRY_ALPHA3_CODE: "PSE",
    COUNTRY_NUMERIC_CODE: 275,
    COUNTRY_NAME: "Palestine, State of",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "PT",
    COUNTRY_ALPHA3_CODE: "PRT",
    COUNTRY_NUMERIC_CODE: 620,
    COUNTRY_NAME: "Portugal",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "PW",
    COUNTRY_ALPHA3_CODE: "PLW",
    COUNTRY_NUMERIC_CODE: 585,
    COUNTRY_NAME: "Palau",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "PY",
    COUNTRY_ALPHA3_CODE: "PRY",
    COUNTRY_NUMERIC_CODE: 600,
    COUNTRY_NAME: "Paraguay",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "QA",
    COUNTRY_ALPHA3_CODE: "QAT",
    COUNTRY_NUMERIC_CODE: 634,
    COUNTRY_NAME: "Qatar",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "RE",
    COUNTRY_ALPHA3_CODE: "REU",
    COUNTRY_NUMERIC_CODE: 638,
    COUNTRY_NAME: "Reunion",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "RO",
    COUNTRY_ALPHA3_CODE: "ROU",
    COUNTRY_NUMERIC_CODE: 642,
    COUNTRY_NAME: "Romania",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "RS",
    COUNTRY_ALPHA3_CODE: "SRB",
    COUNTRY_NUMERIC_CODE: 688,
    COUNTRY_NAME: "Serbia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "RU",
    COUNTRY_ALPHA3_CODE: "RUS",
    COUNTRY_NUMERIC_CODE: 643,
    COUNTRY_NAME: "Russian Federation",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "RW",
    COUNTRY_ALPHA3_CODE: "RWA",
    COUNTRY_NUMERIC_CODE: 646,
    COUNTRY_NAME: "Rwanda",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "SA",
    COUNTRY_ALPHA3_CODE: "SAU",
    COUNTRY_NUMERIC_CODE: 682,
    COUNTRY_NAME: "Saudi Arabia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "SB",
    COUNTRY_ALPHA3_CODE: "SLB",
    COUNTRY_NUMERIC_CODE: 90,
    COUNTRY_NAME: "Solomon Islands",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "SC",
    COUNTRY_ALPHA3_CODE: "SYC",
    COUNTRY_NUMERIC_CODE: 690,
    COUNTRY_NAME: "Seychelles",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "SD",
    COUNTRY_ALPHA3_CODE: "SDN",
    COUNTRY_NUMERIC_CODE: 729,
    COUNTRY_NAME: "Sudan",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "SE",
    COUNTRY_ALPHA3_CODE: "SWE",
    COUNTRY_NUMERIC_CODE: 752,
    COUNTRY_NAME: "Sweden",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "SG",
    COUNTRY_ALPHA3_CODE: "SGP",
    COUNTRY_NUMERIC_CODE: 702,
    COUNTRY_NAME: "Singapore",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "SH",
    COUNTRY_ALPHA3_CODE: "SHN",
    COUNTRY_NUMERIC_CODE: 654,
    COUNTRY_NAME: "Saint Helena, Ascension and Tristan da Cunha",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "SI",
    COUNTRY_ALPHA3_CODE: "SVN",
    COUNTRY_NUMERIC_CODE: 705,
    COUNTRY_NAME: "Slovenia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "SJ",
    COUNTRY_ALPHA3_CODE: "SJM",
    COUNTRY_NUMERIC_CODE: 744,
    COUNTRY_NAME: "Svalbard and Jan Mayen",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "SK",
    COUNTRY_ALPHA3_CODE: "SVK",
    COUNTRY_NUMERIC_CODE: 703,
    COUNTRY_NAME: "Slovakia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "SL",
    COUNTRY_ALPHA3_CODE: "SLE",
    COUNTRY_NUMERIC_CODE: 694,
    COUNTRY_NAME: "Sierra Leone",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "SM",
    COUNTRY_ALPHA3_CODE: "SMR",
    COUNTRY_NUMERIC_CODE: 674,
    COUNTRY_NAME: "San Marino",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "SN",
    COUNTRY_ALPHA3_CODE: "SEN",
    COUNTRY_NUMERIC_CODE: 686,
    COUNTRY_NAME: "Senegal",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "SO",
    COUNTRY_ALPHA3_CODE: "SOM",
    COUNTRY_NUMERIC_CODE: 706,
    COUNTRY_NAME: "Somalia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "SR",
    COUNTRY_ALPHA3_CODE: "SUR",
    COUNTRY_NUMERIC_CODE: 740,
    COUNTRY_NAME: "Suriname",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "SS",
    COUNTRY_ALPHA3_CODE: "SSD",
    COUNTRY_NUMERIC_CODE: 728,
    COUNTRY_NAME: "South Sudan",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "ST",
    COUNTRY_ALPHA3_CODE: "STP",
    COUNTRY_NUMERIC_CODE: 678,
    COUNTRY_NAME: "Sao Tome and Principe",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "SV",
    COUNTRY_ALPHA3_CODE: "SLV",
    COUNTRY_NUMERIC_CODE: 222,
    COUNTRY_NAME: "El Salvador",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "SX",
    COUNTRY_ALPHA3_CODE: "SXM",
    COUNTRY_NUMERIC_CODE: 534,
    COUNTRY_NAME: "Sint Maarten (Dutch Part)",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "SY",
    COUNTRY_ALPHA3_CODE: "SYR",
    COUNTRY_NUMERIC_CODE: 760,
    COUNTRY_NAME: "Syrian Arab Republic",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "SZ",
    COUNTRY_ALPHA3_CODE: "SWZ",
    COUNTRY_NUMERIC_CODE: 748,
    COUNTRY_NAME: "Eswatini",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "TC",
    COUNTRY_ALPHA3_CODE: "TCA",
    COUNTRY_NUMERIC_CODE: 796,
    COUNTRY_NAME: "Turks and Caicos Islands",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "TD",
    COUNTRY_ALPHA3_CODE: "TCD",
    COUNTRY_NUMERIC_CODE: 148,
    COUNTRY_NAME: "Chad",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "TF",
    COUNTRY_ALPHA3_CODE: "ATF",
    COUNTRY_NUMERIC_CODE: 260,
    COUNTRY_NAME: "French Southern Territories",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "TG",
    COUNTRY_ALPHA3_CODE: "TGO",
    COUNTRY_NUMERIC_CODE: 768,
    COUNTRY_NAME: "Togo",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "TH",
    COUNTRY_ALPHA3_CODE: "THA",
    COUNTRY_NUMERIC_CODE: 764,
    COUNTRY_NAME: "Thailand",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "TJ",
    COUNTRY_ALPHA3_CODE: "TJK",
    COUNTRY_NUMERIC_CODE: 762,
    COUNTRY_NAME: "Tajikistan",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "TK",
    COUNTRY_ALPHA3_CODE: "TKL",
    COUNTRY_NUMERIC_CODE: 772,
    COUNTRY_NAME: "Tokelau",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "TL",
    COUNTRY_ALPHA3_CODE: "TLS",
    COUNTRY_NUMERIC_CODE: 626,
    COUNTRY_NAME: "Timor-Leste",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "TM",
    COUNTRY_ALPHA3_CODE: "TKM",
    COUNTRY_NUMERIC_CODE: 795,
    COUNTRY_NAME: "Turkmenistan",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "TN",
    COUNTRY_ALPHA3_CODE: "TUN",
    COUNTRY_NUMERIC_CODE: 788,
    COUNTRY_NAME: "Tunisia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "TO",
    COUNTRY_ALPHA3_CODE: "TON",
    COUNTRY_NUMERIC_CODE: 776,
    COUNTRY_NAME: "Tonga",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "TR",
    COUNTRY_ALPHA3_CODE: "TUR",
    COUNTRY_NUMERIC_CODE: 792,
    COUNTRY_NAME: "Turkey",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "TT",
    COUNTRY_ALPHA3_CODE: "TTO",
    COUNTRY_NUMERIC_CODE: 780,
    COUNTRY_NAME: "Trinidad and Tobago",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "TV",
    COUNTRY_ALPHA3_CODE: "TUV",
    COUNTRY_NUMERIC_CODE: 798,
    COUNTRY_NAME: "Tuvalu",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "TW",
    COUNTRY_ALPHA3_CODE: "TWN",
    COUNTRY_NUMERIC_CODE: 158,
    COUNTRY_NAME: "Taiwan (Province of China)",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "TZ",
    COUNTRY_ALPHA3_CODE: "TZA",
    COUNTRY_NUMERIC_CODE: 834,
    COUNTRY_NAME: "Tanzania, United Republic of",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "UA",
    COUNTRY_ALPHA3_CODE: "UKR",
    COUNTRY_NUMERIC_CODE: 804,
    COUNTRY_NAME: "Ukraine",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "UG",
    COUNTRY_ALPHA3_CODE: "UGA",
    COUNTRY_NUMERIC_CODE: 800,
    COUNTRY_NAME: "Uganda",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "UM",
    COUNTRY_ALPHA3_CODE: "UMI",
    COUNTRY_NUMERIC_CODE: 581,
    COUNTRY_NAME: "United States Minor Outlying Islands",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "US",
    COUNTRY_ALPHA3_CODE: "USA",
    COUNTRY_NUMERIC_CODE: 840,
    COUNTRY_NAME: "United States of America",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "UY",
    COUNTRY_ALPHA3_CODE: "URY",
    COUNTRY_NUMERIC_CODE: 858,
    COUNTRY_NAME: "Uruguay",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "UZ",
    COUNTRY_ALPHA3_CODE: "UZB",
    COUNTRY_NUMERIC_CODE: 860,
    COUNTRY_NAME: "Uzbekistan",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "VA",
    COUNTRY_ALPHA3_CODE: "VAT",
    COUNTRY_NUMERIC_CODE: 336,
    COUNTRY_NAME: "Holy See",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "VC",
    COUNTRY_ALPHA3_CODE: "VCT",
    COUNTRY_NUMERIC_CODE: 670,
    COUNTRY_NAME: "Saint Vincent and the Grenadines",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "VE",
    COUNTRY_ALPHA3_CODE: "VEN",
    COUNTRY_NUMERIC_CODE: 862,
    COUNTRY_NAME: "Venezuela (Bolivarian Republic of)",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "VG",
    COUNTRY_ALPHA3_CODE: "VGB",
    COUNTRY_NUMERIC_CODE: 92,
    COUNTRY_NAME: "Virgin Islands (British)",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "VI",
    COUNTRY_ALPHA3_CODE: "VIR",
    COUNTRY_NUMERIC_CODE: 850,
    COUNTRY_NAME: "Virgin Islands (U.S.)",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "VN",
    COUNTRY_ALPHA3_CODE: "VNM",
    COUNTRY_NUMERIC_CODE: 704,
    COUNTRY_NAME: "Viet Nam",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "VU",
    COUNTRY_ALPHA3_CODE: "VUT",
    COUNTRY_NUMERIC_CODE: 548,
    COUNTRY_NAME: "Vanuatu",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "WF",
    COUNTRY_ALPHA3_CODE: "WLF",
    COUNTRY_NUMERIC_CODE: 876,
    COUNTRY_NAME: "Wallis and Futuna",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "WS",
    COUNTRY_ALPHA3_CODE: "WSM",
    COUNTRY_NUMERIC_CODE: 882,
    COUNTRY_NAME: "Samoa",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "YE",
    COUNTRY_ALPHA3_CODE: "YEM",
    COUNTRY_NUMERIC_CODE: 887,
    COUNTRY_NAME: "Yemen",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "YT",
    COUNTRY_ALPHA3_CODE: "MYT",
    COUNTRY_NUMERIC_CODE: 175,
    COUNTRY_NAME: "Mayotte",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "ZA",
    COUNTRY_ALPHA3_CODE: "ZAF",
    COUNTRY_NUMERIC_CODE: 710,
    COUNTRY_NAME: "South Africa",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "ZM",
    COUNTRY_ALPHA3_CODE: "ZMB",
    COUNTRY_NUMERIC_CODE: 894,
    COUNTRY_NAME: "Zambia",
  },
  {
    LANG: "EN",
    LANG_NAME: "ENGLISH",
    COUNTRY_ALPHA2_CODE: "ZW",
    COUNTRY_ALPHA3_CODE: "ZWE",
    COUNTRY_NUMERIC_CODE: 716,
    COUNTRY_NAME: "Zimbabwe",
  },
];
export const paidSections = [
  "projects",
  "volunteering",
  "onlinePresence",
  "certifications",
  "references",
  "publications",
  "books",
  "additionalExperience",
  "additionalSkills",
  "courses",
  "industryExpertise",
  "techStack",
  "strengths",
  "customDateSection",
  "customTextSection",
];
export const customField = {
  customTitle: "",
  data: [
    {
      custom_title: "",
      display_name: "",
      icon: "",
    },
  ],
};

export const experience = {
  show: true,
  customTitle: "Work Experience",
  timelineWidth: 136,
  data: [
    {
      position: "",
      company: null,
      startFrom: "Jan/2018",
      endUntil: "Present",
      website: null,
      location: null,
      description: null,
      dateRange: {
        fromYear: null,
        fromMonth: null,
        toYear: null,
        toMonth: null,
        isOnGoing: false,
        onGoingText: "Ongoing",
      },
      showFields: {
        position: true,
        company: true,
        date: true,
        location: true,
        website: true,
        description: true,
      },
    },
  ],
};

export const skills = {
  show: true,
  customTitle: null,
  data: [
    {
      name: null,
      icon: "",
      level: 50,
      description: null,
      showFields: { name: true, slider: true, description: true },
    },
  ],
};

export const summary = {
  show: true,
  customTitle: "",
  data: [
    {
      description: null,
    },
  ],
};

export const education = {
  show: true,
  customTitle: "Education",
  data: [
    {
      degree: null,
      school: null,
      startFrom: null,
      endUntil: null,
      website: null,
      location: null,
      gpa: "",
      gpaText: "",
      maxGpa: "",
      description: null,
      dateRange: {
        fromYear: null,
        fromMonth: null,
        toYear: null,
        toMonth: null,
        isOnGoing: false,
        onGoingText: "Ongoing",
      },
      showFields: {
        degree: true,
        school: true,
        date: true,
        location: true,
        website: true,
        description: true,
      },
    },
  ],
};

export const achievements = {
  show: true,
  customTitle: null,
  data: [
    {
      name: null,
      description: null,
      icon: "",
      showFields: { name: true, icon: true, description: true },
    },
  ],
};

export const interests = {
  show: true,
  showIcons: true,
  customTitle: null,
  data: [
    {
      name: null,
      level: null,
      icon: "fa fa-book",
      description: "",
      showFields: { name: true, level: true, icon: true, description: true },
    },
  ],
};

export const strengths = {
  show: true,
  showIcons: true,
  customTitle: null,
  data: [
    {
      name: null,
      icon: "fa fa-bolt",
      showFields: { name: true, icon: true },
    },
  ],
};

export const languages = {
  show: true,
  customTitle: null,
  data: [
    {
      name: null,
      level: 6,
      levelText: "",
      showFields: {
        name: true,
        slider: true,
        description: true,
        proficiencyText: true,
      },
    },
  ],
};

export const customDate = {
  show: true,
  customTitle: "",
  data: [
    {
      title: "",
      startFrom: "",
      endUntil: "",
      description: "",
      dateRange: {
        fromYear: null,
        fromMonth: null,
        toYear: null,
        toMonth: null,
        isOnGoing: false,
        onGoingText: "Ongoing",
      },
      showFields: {
        date: true,
        description: true,
        icon: true,
      },
    },
  ],
};

export const customText = {
  show: true,
  customTitle: "",
  data: [
    {
      title: "",
      description: "",
      showFields: {
        description: true,
      },
    },
  ],
};

// export const references = {
//   show: true,
//   customTitle: "",
//   data: [
//     {
//       name: "",
//       company: "",
//       phone: "",
//       email: "",
//     },
//   ],
// };

export const social = {
  show: true,
  customTitle: "",
  data: [
    {
      label: "",
      link: "",
    },
  ],
};

export const style = {
  fontSize: 2,
  titleFont: "Montserrat",
  bodyFont: "Montserrat",
  linkColor: "#616265",
  primaryColor: "#1F1F1F",
  secondaryColor: "#701233",
  descriptionColor: "#1F1F1F",
  titleBgColor: "#efe9e0",
  initialLoad: true,
  grid_width: 260,
  resumeLayout: "single",
  SectionMargin: "2",
  PageMargin: "2",
  bgColor: {
    bgColor: "#ffffff",
    bgFill: "full",
    varients: [],
  },
  multi_color_option: [
    {
      primary_color: "#e52165",
      secondary_color: "#0d1137",
    },
    {
      primary_color: "#d72631",
      secondary_color: "#a2d5c6",
    },
    {
      primary_color: "#077b8a",
      secondary_color: "#5c3c92",
    },
    {
      primary_color: "#e2d810",
      secondary_color: "#d9138a",
    },
  ],
  background: {
    bgShow: false,
    bgImage: "bg3.svg",
  },
};

export const layout = [
  [
    {
      page: 0,
      height: 379,
      section: "profile",
      itemIndexes: [0],
    },
    {
      page: 0,
      height: 98,
      section: "summary",
      itemIndexes: [0],
    },
    {
      page: 0,
      height: 192,
      section: "experience",
      itemIndexes: [0, 1],
    },
    {
      page: 0,
      height: 136,
      section: "education",
      itemIndexes: [0, 1],
    },
    {
      page: 0,
      height: 120,
      section: "skills",
      itemIndexes: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    },
    {
      page: 0,
      height: 99,
      section: "achievements",
      itemIndexes: [0, 1, 2, 3],
    },
  ],
  [],
];
export const settings = {
  showIcon: true,
  sectionHeaderUnderline: false,
  isTitleBackgroundColor: true,
  skills: {
    sliderType: 2,
    headerStyle: "Header1",
    sliders: ["dots", "range"],
    skillColor: {
      c_forty: "#f44336",
      c_sixty: "#808080",
      c_eighty: "#2196F3",
      c_twenty: "#f44336",
      c_hundred: "#04AA6D",
    },
  },
  profile: {
    photoStyle: "square",
    headerStyle: "Word1",
    profileSize: "medium",
  },
  education: {
    headerStyle: "Header3",
  },
  interests: {
    headerStyle: "Header1",
  },
  languages: {
    levelTexts: {
      low: "Beginer",
      good: "Beginer",
      expert: "Beginer",
      veryLow: "Beginer",
      intermediate: "Beginer",
    },
    headerStyle: "Header1",
    indicatorType: "dots",
  },
  experience: {
    headerStyle: "Header2",
  },
  achievements: {
    headerStyle: "Header1",
  },
  additionalSkills: {
    border: true,
  },
};
export const defaultResumeData = {
  profile: profile,
  summary: summary,
  experience: experience,
  education: education,
  skills: skills,
  achievements: achievements,
  languages: languages,
  interests: interests,
  //   customDate: customDate,
  //   customText: customText,
  // references: references,
  social: social,
  sectionPosition: {
    page: 0,
    lsbar: [
      "profile",
      "summary",
      "experience",
      "education",
      "skills",
      "achievements",
    ],
    rsbar: [],
    restrictions: {
      lsbar: ["experience"],
      rsbar: ["languages"],
    },
  },
  layout: layout,
  editorSettings: settings,
  customization: style,
  sectionTitles: {},
};

const masterData = [];

export const from = {
  name: "",
  jobTitle: "",
  address: "",
  email: "",
  phone: "",
  city: "",
  website: "",
};

export const to = {
  hr_name: "",
  companyName: "",
  companyAddress: "",
  city: "",
  date: "",
};

export const content = {
  description: "<p><br></p>",
};

export const coverSettings = {
  showIcon: false,
  from: {
    headerStyle: "Header1",
    photoStyle: "square",
    profileSize: "large",
    defaultHeader: "Header1",
    isdefaultHeader: true,
    showdefaultHeader: true,
    isBorder: true,
  },
  to: {
    headerStyle: "Header1",
  },
  content: {
    headerStyle: "Header1",
  },
};

export const coverStyle = {
  colors: {
    primaryColor: "#27496d",
    secondaryColor: "#00909e",
    sectionTitleColor: "#cd7e31",
    descriptionColor: "#656665",
    bgColor: "#ffffff",
  },
  background: {
    bgShow: false,
    bgImage: "c-bg1.png",
  },
  fonts: {
    titleFont: "Roboto",
    bodyFont: "Roboto",
    titleFontSize: "20px",
    bodyFontSize: "16px",
    bold: "700",
    medium: "500",
    regular: "400",
    multi_color_option: [
      {
        primary_color: "#27496d",
        secondary_color: "#00909e",
      },
      {
        primary_color: "#27496d",
        secondary_color: "#00909e",
      },
      {
        primary_color: "#27496d",
        secondary_color: "#00909e",
      },
      {
        primary_color: "#27496d",
        secondary_color: "#00909e",
      },
    ],
  },
  SectionMargin: "12px",
  PageMargin: "30px",
};

export const defaultCoverData = {
  from: from,
  to: to,
  content: content,
  editorSettings: coverSettings,
  customization: coverStyle,
};

// export const availableSection = [
//   {
//     sectionId: "summary",
//     image: "/images/Language.svg",
//     font_class: "fa fa-diamond",
//   },
//   {
//     sectionId: "experience",
//     image: "/images/Internship.svg",
//     font_class: "fa fa-briefcase",
//   },
//   {
//     sectionId: "education",
//     image: "/images/education.svg",
//     font_class: "fa fa-graduation-cap",
//   },
//   {
//     sectionId: "skills",
//     image: "/images/skill.svg",
//     font_class: "fa fa-shield",
//   },
//   {
//     sectionId: "languages",
//     image: "/images/Language.svg",
//     font_class: "fa fa-language",
//   },
//   {
//     sectionId: "achievements",
//     image: "/images/Hobbies.svg",
//     font_class: "fa fa-trophy",
//   },
//   {
//     sectionId: "interests",
//     image: "/images/interest.svg",
//     font_class: "fa fa-th",
//   },
//   {
//     sectionId: "projects",
//     image: "/images/interest.svg",
//     font_class: "fa fa-file-powerpoint-o",
//   },
//   {
//     sectionId: "volunteering",
//     image: "/images/interest.svg",
//     font_class: "fa fa-users",
//   },
//   {
//     sectionId: "onlinePresence",
//     image: "/images/interest.svg",
//     font_class: "fa fa-share-square-o",
//   },
//   {
//     sectionId: "certifications",
//     image: "/images/interest.svg",
//     font_class: "fa fa-certificate",
//   },
//   {
//     sectionId: "references",
//     image: "/images/interest.svg",
//     font_class: "fa fa-user",
//   },
//   {
//     sectionId: "publications",
//     image: "/images/interest.svg",
//     font_class: "fa fa-language",
//   },
//   {
//     sectionId: "books",
//     image: "/images/interest.svg",
//     font_class: "fa fa-book",
//   },
//   {
//     sectionId: "additionalExperience",
//     image: "/images/interest.svg",
//     font_class: "fa fa-briefcase",
//   },
//   {
//     sectionId: "additionalSkills",
//     image: "/images/interest.svg",
//     font_class: "fa fa-shield",
//   },
//   {
//     sectionId: "courses",
//     image: "/images/interest.svg",
//     font_class: "fa fa-book",
//   },
//   {
//     sectionId: "industryExpertise",
//     image: "/images/interest.svg",
//     font_class: "fa fa-briefcase",
//   },
//   {
//     sectionId: "strengths",
//     image: "/images/interest.svg",
//     font_class: "fa fa-briefcase",
//   },
//   //   {
//   //     sectionId: "customDate",
//   //     image: "/images/interest.svg",
//   //   },
//   //   {
//   //     sectionId: "customText",
//   //     image: "/images/interest.svg",
//   //   },
// ];

// export const backgroundImage = [
//   "bg1.png",
//   "bg2.svg",
//   "bg3.svg",
//   "bg4.svg",
//   "bg5.png",
//   "bg6.png",
//   "bg7.png",
//   "bg8.png",
//   "bg9.png",
//   "bg10.png",
//   // "bg11.png",
//   "bg12.png",
//   "bg13.png",
//   "bg14.png",
//   "bg15.png",
//   "bg16.png",
// ];

export const coverBackgroundImage = [
  "c-bg1.png",
  "c-bg2.png",
  "c-bg3.png",
  "c-bg4.png",
];

export const sampleSuggestion = [
  {
    description:
      "Worked to ensure a positive and hassle-free customer experience.",
  },
  {
    description:
      "Settled any customer disputes in a professional and pleasant manner.",
  },
  {
    description:
      "Identified and maximized sales opportunities, and increased customer retention rates.",
  },
  {
    description: "Handled food with sanitation and safety in mind.",
  },
  {
    description:
      "Worked to ensure a neat and attractive sales environment, and assisted in the setup of visual displays.",
  },
  {
    description:
      "Helped to increase customer return rates by providing excellent customer service at all times.",
  },
  {
    description:
      "Brought forth excellent customer service skills and a committment to customer satisfaction.",
  },
];

export const projects = {
  show: true,
  showIcons: true,
  customTitle: null,
  data: [
    {
      name: null,
      location: null,
      dateRange: {
        fromYear: null,
        fromMonth: null,
        toYear: null,
        toMonth: null,
        isOnGoing: false,
        onGoingText: "Ongoing",
      },
      icon: "129-free-heart",
      description: "",

      showFields: {
        name: true,
        location: true,
        icon: true,
        description: true,
        date: true,
      },
    },
  ],
};

export const volunteering = {
  show: true,
  showIcons: true,
  customTitle: null,
  data: [
    {
      name: null,
      organization: null,
      dateRange: {
        fromYear: null,
        fromMonth: null,
        toYear: null,
        toMonth: null,
        isOnGoing: false,
        onGoingText: "Ongoing",
      },
      icon: "129-free-heart",
      description: "",

      showFields: {
        name: true,
        organization: true,
        icon: true,
        description: true,
        date: true,
      },
    },
  ],
};
export const onlinePresence = {
  show: true,
  showIcons: true,
  customTitle: null,
  data: [
    {
      socialNetwork: null,
      userName: null,
      icon: "129-free-heart",

      showFields: {
        socialNetwork: true,
        userName: true,
        icon: true,
      },
    },
  ],
};
export const certifications = {
  show: true,
  showIcons: true,
  customTitle: null,
  data: [
    {
      name: null,
      icon: "129-free-heart",
      description: "",
      showFields: {
        name: true,
        icon: true,
        description: true,
      },
    },
  ],
};
export const references = {
  show: true,
  showIcons: true,
  customTitle: null,
  data: [
    {
      name: null,
      referenceName: null,
      referenceContact: null,
      icon: "129-free-heart",

      showFields: {
        referenceName: true,
        referenceContact: true,
        icon: true,
      },
    },
  ],
};
export const publications = {
  show: true,
  showIcons: true,
  customTitle: null,
  data: [
    {
      name: null,
      publishingCompany: null,
      authors: null,
      dateRange: {
        fromYear: null,
        fromMonth: null,
        toYear: null,
        toMonth: null,
        isOnGoing: false,
        onGoingText: "Ongoing",
      },
      icon: "129-free-heart",
      description: "",

      showFields: {
        name: true,
        publishingCompany: true,
        authors: true,
        icon: true,
        description: true,
        date: true,
      },
    },
  ],
};
export const books = {
  show: true,
  showIcons: true,
  customTitle: null,
  data: [
    {
      title: null,
      authors: null,
      icon: "129-free-heart",
      image: null,

      showFields: {
        title: true,
        authors: true,
        icon: true,
        image: true,
      },
    },
  ],
};
export const additionalExperience = {
  show: true,
  showIcons: true,
  customTitle: null,
  data: [
    {
      name: null,
      company: null,
      location: null,
      dateRange: {
        fromYear: null,
        fromMonth: null,
        toYear: null,
        toMonth: null,
        isOnGoing: false,
        onGoingText: "Ongoing",
      },
      icon: "129-free-heart",
      description: "",

      showFields: {
        name: true,
        company: true,
        location: true,
        icon: true,
        description: true,
        date: true,
      },
    },
  ],
};
export const additionalSkills = {
  show: true,
  showIcons: true,
  customTitle: null,
  data: [
    {
      name: null,
      icon: "129-free-heart",

      showFields: {
        name: true,
        icon: true,
      },
    },
  ],
};
export const courses = {
  show: true,
  showIcons: true,
  customTitle: null,
  data: [
    {
      name: null,
      icon: "129-free-heart",

      showFields: {
        name: true,
        icon: true,
      },
    },
  ],
};
export const industryExpertise = {
  show: true,
  showIcons: true,
  customTitle: null,
  data: [
    {
      name: null,
      icon: "",
      level: 50,
      description: null,
      showFields: { name: true, slider: true, description: true },
    },
  ],
};
export const techStack = {
  show: true,
  showIcons: true,
  customTitle: null,
  data: [
    {
      name: null,
      location: null,
      dateRange: {
        fromYear: null,
        fromMonth: null,
        toYear: null,
        toMonth: null,
        isOnGoing: false,
        onGoingText: "Ongoing",
      },
      icon: "129-free-heart",
      description: "",

      showFields: {
        name: true,
        location: true,
        icon: true,
        description: true,
        date: true,
      },
    },
  ],
};
export const sampleData = {
  summary:
    "Over 4 years of experience as Assistant Behavior Analyst in the Educational domain with expertise in providing quality Behavioural services to students and staff training based on current practices in Applied Behavior Analysis.",
  experience: [
    {
      position: "Behavior Analyst - Education",
      company: "Hogan Learning Academy",
      startFrom: "Nov 2015",
      endUntil: "Present",
      website: "Hogan Learning Academy",
      location: "Fleetwood, PA",
      description:
        "<ul>\n<li>Execute and follow the ethical standards for behavior analysts as outlined through the BACB.</li>\n<li>Maintain client confidentiality through the standards set through FERPA / HIPAA privacy rule and the BACB.</li>\n<li>Conduct functional behavior assessment (FBA) for each assigned student and develop behavioral goals for each assigned students' IEP and behavior support plan.</li>\n<li>Develop lesson plans and mastery criteria for students' behavioral goals.</li>\n<li>Develop specific, individualized systems of data collection for each assigned student.</li>\n<li>Execution of data collection methods to support interventions and behavior change.</li>\n<li>Revise and update behavior support plans and behavior goals as data suggest the need for intervention change.</li>\n<li>Oversee staff implementation of behavior support plans and behavior goals.</li>\n</ol>",
      showFields: {
        position: true,
        company: true,
        date: true,
        location: true,
        website: true,
        description: true,
      },
      dateRange: {
        fromYear: 2019,
        fromMonth: "Jan",
        toYear: 2022,
        toMonth: "Jan",
        isOnGoing: true,
        onGoingText: "",
      },
    },
    {
      position: "Behavior Analyst",
      company: "ABC Corp",
      startFrom: "May 2013",
      endUntil: "Nov 2015",
      website: "ABC Corp",
      location: "Austin, TX",
      description:
        '<ul>\n<li class="content">Behavior Analysts are responsible for conducting functional assessments, preference assessments, developing behavior analysis service plans, implementing acquisition and replacement programs, collecting data for target behaviors, and graph data accordingly on monthly progress reports; training and monitoring behavior assistants in the implementation and data collection of target behaviors.</li>\n<li class="content">Behavior analysts are responsible for training and monitoring parents and caregivers in the implementation of the program.</li>\n<li class="content">\n<div class="content">Implemented behavioral programs and established a rapport with the clients.</div>\n</li>\n<li class="content">\n<div class="content">Applied behavior implementation techniques to autistic children and provided in-home-supportive services to families.</div>\n</li>\n</ol>',
      showFields: {
        position: true,
        company: true,
        date: true,
        location: true,
        website: true,
        description: true,
      },
      dateRange: {
        fromYear: 2019,
        fromMonth: "Jan",
        toYear: 2022,
        toMonth: "Jan",
        isOnGoing: true,
        onGoingText: "",
      },
    },
  ],

  education: [
    {
      degree: "\nBachelor Of Arts In Applied Psychology ",
      school: "The Pennsylvania State University",
      startFrom: "Mar 2011",
      endUntil: "Dec 2015",
      website: null,
      location: null,
      gpa: "",
      gpaText: "",
      maxGpa: "",
      description: "",
      showFields: {
        degree: true,
        school: true,
        date: true,
        location: true,
        website: true,
        description: true,
      },
      dateRange: {
        fromYear: 2019,
        fromMonth: "Jan",
        toYear: 2022,
        toMonth: "Jan",
        isOnGoing: true,
        onGoingText: "",
      },
    },
  ],
  skills: [
    {
      name: "Behavioral Assessments",
      icon: "",
      level: 50,
      description: "",
      showFields: {
        name: true,
        slider: true,
        description: true,
      },
    },
    {
      name: " Adaptive Assessments",
      icon: "",
      level: 50,
      description: "",
      showFields: {
        name: true,
        slider: true,
        description: true,
      },
    },
    {
      name: " Data Collection",
      icon: "",
      level: 50,
      description: "",
      showFields: {
        name: true,
        slider: true,
        description: true,
      },
    },
    {
      name: " Staff Training",
      icon: "",
      level: 50,
      description: "",
      showFields: {
        name: true,
        slider: true,
        description: true,
      },
    },
    {
      name: " Client confidentiality standards set by FERPA / HIPPA Privacy Rules.",
      icon: "",
      level: 50,
      description: "",
      showFields: {
        name: true,
        slider: true,
        description: true,
      },
    },
  ],
};
// export const pageMargins = [30, 40, 50, 60];
// export const sectionPaddings = [25, 30, 40, 50];
// export const inbetweenSectionPaddings = [5, 5, 8, 10];
// export const fontVariations = [
//   {
//     h1: "30px",
//     h1_lineHeight: "36px",
//     h2: "16px",
//     h2_lineHeight: "20px",
//     h3: "15px",
//     h3_lineHeight: "19px",
//     h4: "14px",
//     h4_lineHeight: "18px",
//     p1: "13px",
//     p1_lineHeight: "17px",
//     p2: "11px",
//     p2_lineHeight: "13px",
//     tool: "14px",
//     tool_lineHeight: "18px",
//   },
//   {
//     h1: "34px",
//     h1_lineHeight: "40px",
//     h2: "18px",
//     h2_lineHeight: "22px",
//     h3: "16px",
//     h3_lineHeight: "20px",
//     h4: "14px",
//     h4_lineHeight: "18px",
//     p1: "14px",
//     p1_lineHeight: "18px",
//     p2: "11px",
//     p2_lineHeight: "13px",
//     tool: "14px",
//     tool_lineHeight: "18px",
//   },
//   {
//     h1: "38px",
//     h1_lineHeight: "42px",
//     h2: "20px",
//     h2_lineHeight: "24px",
//     h3: "18px",
//     h3_lineHeight: "22px",
//     h4: "15px",
//     h4_lineHeight: "19px",
//     p1: "15px",
//     p1_lineHeight: "19px",
//     p2: "12px",
//     p2_lineHeight: "13px",
//     tool: "15px",
//     tool_lineHeight: "19px",
//   },
//   {
//     h1: "42px",
//     h1_lineHeight: "48px",
//     h2: "24px",
//     h2_lineHeight: "28px",
//     h3: "20px",
//     h3_lineHeight: "24px",
//     h4: "15px",
//     h4_lineHeight: "19px",
//     p1: "15px",
//     p1_lineHeight: "19px",
//     p2: "12px",
//     p2_lineHeight: "13px",
//     tool: "16px",
//     tool_lineHeight: "20px",
//   },
// ];

export const profileSectionMargin = ["4px", "6px", "8px", "16px", "16px"];
export const otherSectionMargin = ["8px", "12px", "14px", "16px", "18px"];
export const sectionPadding = [
  "4px 10px",
  "6px 12px",
  "8px 16px",
  "12px 16px",
  "16px 24px",
];
export const sectionPaddingMargin = [
  "4px 10px 0px",
  "6px 12px 0px",
  "8px 16px 0px",
  "12px 16px 0px",
  "16px 24px 0px",
];
// export const skillSliderTypes = [1, 2, 3, 4];
// export const profileImageTypes = ["round", "square"];
export const newFonts = {
  common: [
    {
      sectionHeader: "16px",
      sectionHeaderLineHeight: "19px",
      fontLargeSize: "14px",
      fontLargeLineHeight: "15px",
      fontMediumSize: "13px",
      fontMediumLineHeight: "15px",
      fontSmallSize: "12px",
      fontSmallLineHeight: "15px",
      description: "12px",
    },
    {
      sectionHeader: "18px",
      sectionHeaderLineHeight: "21px",
      fontLargeSize: "16px",
      fontLargeLineHeight: "19px",
      fontMediumSize: "14px",
      fontMediumLineHeight: "17px",
      fontSmallSize: "12px",
      fontSmallLineHeight: "15px",
      description: "12px",
    },
    {
      sectionHeader: "22px",
      sectionHeaderLineHeight: "26px",
      fontLargeSize: "17px",
      fontLargeLineHeight: "20px",
      fontMediumSize: "15px",
      fontMediumLineHeight: "18px",
      fontSmallSize: "13px",
      fontSmallLineHeight: "16px",
      description: "12px",
    },
    {
      // sectionHeader: "28px",
      sectionHeader: "24px",
      sectionHeaderLineHeight: "33px",
      fontLargeSize: "19px",
      fontLargeLineHeight: "20px",
      fontMediumSize: "15px",
      fontMediumLineHeight: "18px",
      fontSmallSize: "13px",
      fontSmallLineHeight: "16px",
      description: "13px",
    },
  ],
  profile: [
    {
      name: "30px",
      nameLineHeight: "36px",
      jobTitle: "15px",
      jobLineheight: "18px",
      profileInfo: "12px",
      profileInfoLineHeight: "15px",
    },

    {
      name: "34px",
      nameLineHeight: "1",
      jobTitle: "17px",
      jobLineheight: "20px",
      profileInfo: "12px",
      profileInfoLineHeight: "15px",
    },
    {
      name: "38px",
      nameLineHeight: "1",
      jobTitle: "19px",
      jobLineheight: "23px",
      profileInfo: "12px",
      profileInfoLineHeight: "15px",
    },
    {
      name: "42px",
      nameLineHeight: "1",
      jobTitle: "24px",
      jobLineheight: "25px",
      profileInfo: "12px",
      profileInfoLineHeight: "15px",
    },
  ],
  summary: [
    {
      description: "12px",
      lineHeight: "16px",
    },
    {
      description: "13px",
      lineHeight: "17px",
    },
    {
      description: "14px",
      lineHeight: "18px",
    },
    {
      // description: "15px",
      description: "14px",
      lineHeight: "21px",
    },
  ],
  experience: [
    {
      position: "14px",
      positionLineHeight: "17px",
      company: "13px",
      companyLineHeight: "16px",
      date: "11px",
      dateLineHeight: "13px",
      location: "11px",
      locationLineHeight: "13px",
      bullets: "12px",
      bulletsLineHeight: "15px",
      description: "12px",
      descriptionLineHeight: "15px",
      url: "11px",
      urlLineHeight: "13px",
    },
    {
      position: "16px",
      positionLineHeight: "19px",
      company: "13px",
      companyLineHeight: "16px",
      date: "11px",
      dateLineHeight: "13px",
      location: "11px",
      locationLineHeight: "13px",
      bullets: "12px",
      bulletsLineHeight: "15px",
      description: "12px",
      descriptionLineHeight: "15px",
      url: "11px",
      urlLineHeight: "13px",
    },
    {
      position: "18px",
      positionLineHeight: "21px",
      company: "14px",
      companyLineHeight: "17px",
      date: "11px",
      dateLineHeight: "13px",
      location: "11px",
      locationLineHeight: "13px",
      bullets: "12px",
      bulletsLineHeight: "15px",
      description: "12px",
      descriptionLineHeight: "15px",
      url: "11px",
      urlLineHeight: "13px",
    },
    {
      position: "21px",
      positionLineHeight: "25px",
      company: "15px",
      companyLineHeight: "18px",
      date: "11px",
      dateLineHeight: "13px",
      location: "11px",
      locationLineHeight: "13px",
      bullets: "13px",
      bulletsLineHeight: "16px",
      description: "13px",
      descriptionLineHeight: "16px",
      url: "11px",
      urlLineHeight: "13px",
    },
  ],
  education: [
    {
      degree: "14px",
      degreeLineHeight: "17px",
      school: "13px",
      schoolLineHeight: "16px",
      date: "11px",
      dateLineHeight: "13px",
      location: "11px",
      locationLineHeight: "13px",
      bullets: "12px",
      bulletsLineHeight: "15px",
      description: "12px",
      descriptionLineHeight: "15px",
    },
    {
      degree: "16px",
      degreeLineHeight: "19px",
      school: "13px",
      schoolLineHeight: "16px",
      date: "11px",
      dateLineHeight: "13px",
      location: "11px",
      locationLineHeight: "13px",
      bullets: "12px",
      bulletsLineHeight: "15px",
      description: "12px",
      descriptionLineHeight: "15px",
    },
    {
      degree: "18px",
      degreeLineHeight: "21px",
      school: "14px",
      schoolLineHeight: "17px",
      date: "11px",
      dateLineHeight: "13px",
      location: "11px",
      locationLineHeight: "13px",
      bullets: "12px",
      bulletsLineHeight: "15px",
      description: "12px",
      descriptionLineHeight: "15px",
    },
    {
      degree: "21px",
      degreeLineHeight: "25px",
      school: "15px",
      schoolLineHeight: "18px",
      date: "11px",
      dateLineHeight: "13px",
      location: "11px",
      locationLineHeight: "13px",
      bullets: "13px",
      bulletsLineHeight: "16px",
      description: "13px",
      descriptionLineHeight: "16px",
    },
  ],
};

const SvgOne = ({ color = "#000" }) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 90 82"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.3553 72.482C31.7562 72.0411 31.2135 71.7133 30.6369 71.5098C30.0604 71.3064 29.4612 71.1933 28.8281 71.1707C27.5733 71.1142 26.2053 71.3516 24.894 71.6681C23.5826 71.9959 22.339 72.3802 21.4007 72.6968C20.4737 73.002 19.8745 73.2507 19.8745 73.2507C19.8745 73.2507 20.4623 73.5898 21.4233 73.9967C22.3729 74.4037 23.6956 74.8671 25.1314 75.1158C26.5558 75.3645 28.1159 75.3984 29.4838 75.0028C30.8291 74.6298 31.9823 73.7933 32.3553 72.482Z"
      fill={color}
    />
    <path
      d="M28.3532 66.6712C28.8619 67.8129 29.608 68.932 30.5801 69.6668C31.0662 70.0285 31.6088 70.2998 32.1853 70.4129C32.7618 70.5259 33.3836 70.492 33.994 70.2433C34.0279 68.8755 33.6549 67.7903 33.067 66.8408C32.4792 65.9025 31.6427 65.0886 30.7836 64.3765C29.9245 63.6756 29.0428 63.0878 28.3758 62.6696C27.7089 62.2513 27.2567 62.0139 27.2567 62.0139C27.2567 62.0139 27.268 62.1609 27.2907 62.4209C27.3133 62.6696 27.3585 63.0426 27.4263 63.4834C27.562 64.3539 27.8446 65.5295 28.3532 66.6712Z"
      fill={color}
    />
    <path
      d="M18.9248 69.7348C20.2362 69.667 21.4007 69.1696 22.2146 68.0731C21.5589 66.9088 20.5754 66.2758 19.3883 65.914C18.2013 65.5523 16.8221 65.4506 15.4655 65.4054C14.1089 65.3714 12.7636 65.3941 11.7574 65.4054C10.7286 65.4167 10.0729 65.4393 10.0729 65.4393C10.0729 65.4393 10.2086 65.5636 10.4347 65.801C10.6721 66.0158 11.0113 66.3323 11.4409 66.6827C12.2887 67.3836 13.4984 68.2088 14.8324 68.8079C16.1551 69.407 17.6134 69.7913 18.9248 69.7348Z"
      fill={color}
    />
    <path
      d="M21.4232 64.5464C22.1693 65.4846 23.2093 66.1063 24.4979 66.0498C25.0292 64.7838 24.9388 63.5855 24.577 62.4777C24.2153 61.3812 23.5936 60.3639 22.9493 59.4821C22.3049 58.6004 21.6606 57.8543 21.1745 57.3118C20.9371 57.0405 20.7337 56.8257 20.598 56.6787C20.4624 56.5318 20.3832 56.4526 20.3832 56.4526C20.3832 56.4526 20.338 56.5883 20.2702 56.8257C20.2024 57.0744 20.1345 57.4135 20.0667 57.843C19.9311 58.7022 19.8632 59.8778 20.0441 61.1099C20.2363 62.3421 20.6771 63.5968 21.4232 64.5464Z"
      fill={color}
    />
    <path
      d="M5.35852 55.1412C4.43159 54.8473 3.82117 54.6777 3.82117 54.6777C3.82117 54.6777 3.87769 54.836 3.99073 55.096C4.11507 55.356 4.30724 55.7177 4.54463 56.136C4.78201 56.5655 5.07592 57.0629 5.41504 57.5829C5.58461 57.8429 5.76547 58.1142 5.95764 58.3742L6.10459 58.5776L6.29676 58.8263C6.42111 58.9959 6.55676 59.1542 6.69241 59.3237C7.7776 60.6237 9.12279 61.6071 10.4454 62.0254C11.7679 62.4436 13.0453 62.308 14.1418 61.4941C13.8366 60.1828 13.1018 59.2898 12.1071 58.5098C11.8584 58.3177 11.5871 58.1368 11.3158 57.9446C11.0445 57.7524 10.7506 57.5829 10.4567 57.402C10.1628 57.2212 9.85755 57.0403 9.55234 56.8707C9.25843 56.7125 8.96453 56.5655 8.67062 56.4299C7.495 55.8647 6.28546 55.4351 5.35852 55.1412Z"
      fill={color}
    />
    <path
      d="M14.4706 57.4697C14.821 58.6001 15.6349 59.527 16.8784 59.8209C17.7375 58.7583 18.0201 57.6053 18.0879 56.5088C18.1444 55.4123 18.0088 54.3837 17.8844 53.5132C17.8392 53.1402 17.6923 52.5185 17.5566 52.0324C17.421 51.535 17.2627 51.0829 17.1271 50.6985C16.9914 50.3142 16.8558 50.009 16.7653 49.7942C16.6862 49.5794 16.6297 49.4551 16.6297 49.4551C16.6297 49.4551 16.5393 49.5794 16.4036 49.7942C16.2567 50.0203 16.0758 50.3368 15.8723 50.7324C15.4654 51.5124 14.968 52.6202 14.6289 53.8411C14.5384 54.1463 14.4593 54.4515 14.4028 54.7793C14.3463 55.0732 14.301 55.3671 14.2784 55.6836C14.2558 55.9888 14.2784 56.2941 14.301 56.5993C14.3123 56.8932 14.3915 57.1871 14.4706 57.4697Z"
      fill={color}
    />
    <path
      d="M3.93386 50.5402C4.14864 50.8002 4.39733 51.0376 4.65732 51.2523C4.90601 51.4671 5.17731 51.6706 5.44861 51.8402C6.5338 52.541 7.73204 52.8236 9.04331 52.4506C9.15635 51.7949 9.09983 51.1958 8.93027 50.6419C8.83984 50.3706 8.7268 50.0993 8.57984 49.8506C8.43289 49.5906 8.26333 49.3533 8.09377 49.1046C7.39291 48.1324 6.30772 47.2846 5.21123 46.5272C4.14864 45.7699 3.02954 45.1142 2.17042 44.6395C1.30001 44.176 0.746109 43.8821 0.746109 43.8821C0.746109 43.8821 0.768717 44.0403 0.836542 44.3229C0.91567 44.6055 1.02871 45.0012 1.19827 45.476C1.52609 46.4255 1.97825 47.7029 2.72432 48.8672C3.08606 49.455 3.493 50.0315 3.93386 50.5402Z"
      fill={color}
    />
    <path
      d="M11.0112 50.0317C11.2712 50.5404 11.6442 51.0039 12.1642 51.3656C13.3511 50.6874 14.0294 49.67 14.3911 48.5622C14.4815 48.2909 14.5493 48.0083 14.6059 47.7144C14.6398 47.5675 14.6511 47.4318 14.6737 47.2849C14.6963 47.1379 14.7189 46.9909 14.7415 46.844C14.8206 46.2562 14.8319 45.6797 14.8206 45.1145C14.7528 43.9954 14.6737 42.9441 14.538 42.1754C14.4702 41.7911 14.4024 41.4746 14.3572 41.2598C14.3233 41.045 14.3007 40.9207 14.3007 40.9207C14.3007 40.9207 14.1876 41.0224 14.0067 41.2033C13.8146 41.3841 13.5772 41.6554 13.3059 41.9945C12.752 42.6728 12.0624 43.6449 11.4972 44.7753C10.9659 45.8945 10.6155 47.1605 10.6268 48.3587C10.6268 48.664 10.672 48.9466 10.7399 49.2292C10.7851 49.5118 10.8755 49.7831 11.0112 50.0317Z"
      fill={color}
    />
    <path
      d="M1.65046 39.7677C1.82002 40.0729 1.98958 40.3668 2.19306 40.6268C2.39653 40.8981 2.62261 41.1468 2.86 41.3616C3.79824 42.2659 4.91734 42.7859 6.27383 42.6615C6.51122 42.0398 6.57904 41.452 6.51122 40.8755C6.47731 40.5929 6.40948 40.3103 6.31905 40.0277C6.22862 39.7451 6.13818 39.4738 6.01384 39.2025C5.76515 38.6486 5.41472 38.1173 5.01908 37.5973C4.81561 37.3373 4.60083 37.0773 4.40866 36.8286C4.20518 36.5686 3.9791 36.3199 3.76432 36.0825C2.88261 35.0991 1.89915 34.2061 1.2096 33.5391C0.497442 32.8609 6.20112e-05 32.4426 6.20112e-05 32.4426C6.20112e-05 32.4426 -0.0225462 33.1209 0.0452784 34.1382C0.0791906 34.6469 0.180927 35.2347 0.305272 35.8678C0.361793 36.1843 0.440922 36.5121 0.52005 36.8399C0.599179 37.1677 0.678308 37.5069 0.813957 37.8347C1.04004 38.5016 1.32264 39.1573 1.65046 39.7677Z"
      fill={color}
    />
    <path
      d="M9.50755 41.9379C10.8075 41.497 11.6666 40.6379 12.2318 39.6431C12.3788 39.3944 12.4918 39.1458 12.6049 38.8745C12.7292 38.6145 12.8423 38.3432 12.9327 38.0719C13.1249 37.5293 13.2605 36.9867 13.3509 36.4554C13.4527 35.9241 13.5657 35.4041 13.6109 34.9293C13.6449 34.6806 13.6675 34.4546 13.6788 34.2398C13.6901 34.025 13.7014 33.8215 13.724 33.6294C13.8031 32.8833 13.7918 32.3972 13.7918 32.3972C13.7918 32.3972 13.2944 32.6685 12.571 33.1885C12.3901 33.3128 12.1979 33.4598 11.9945 33.6181C11.791 33.7763 11.5875 33.9572 11.384 34.138C10.9884 34.5111 10.5701 34.9519 10.1858 35.4267C9.99363 35.6641 9.80146 35.9128 9.62059 36.1841C9.53016 36.3084 9.43973 36.4441 9.3606 36.5797C9.28147 36.7154 9.21365 36.851 9.14582 36.9867C8.87452 37.5406 8.67105 38.1171 8.55801 38.7049C8.50149 38.9988 8.46758 39.2814 8.47888 39.5753C8.49019 39.8579 8.5354 40.1405 8.61453 40.4118C8.7954 40.977 9.06669 41.4857 9.50755 41.9379Z"
      fill={color}
    />
    <path
      d="M4.80434 25.5695C4.49913 24.9817 4.17131 24.4165 3.8548 23.8965C3.52698 23.3652 3.23307 22.8792 2.98438 22.4722C2.4757 21.6583 2.10266 21.1157 2.10266 21.1157C2.10266 21.1157 1.91049 21.7601 1.70702 22.7548C1.62789 23.2635 1.56007 23.8513 1.51485 24.4956C1.49224 24.8235 1.46963 25.1513 1.45833 25.4904C1.45833 25.8295 1.48094 26.18 1.51485 26.5304C1.57137 27.2312 1.6618 27.9434 1.84267 28.6103C2.04614 29.2773 2.30614 29.9216 2.63395 30.4642C3.27829 31.572 4.31826 32.3407 5.66345 32.5329C5.84432 32.2616 5.96866 31.979 6.0704 31.7077C6.16083 31.4251 6.26257 31.1538 6.29648 30.8712C6.38691 30.3059 6.3417 29.7181 6.20605 29.1303C6.09301 28.5425 5.91214 27.9434 5.65215 27.3443C5.40346 26.7678 5.09825 26.1573 4.80434 25.5695Z"
      fill={color}
    />
    <path
      d="M12.1189 30.7472C12.5258 30.3515 12.8649 29.8994 13.1588 29.4359C13.4754 28.9724 13.758 28.4977 13.984 28.0116C14.0971 27.7742 14.1875 27.5368 14.3006 27.2994C14.4136 27.0734 14.5153 26.8473 14.6058 26.6212C14.7866 26.1803 14.9223 25.7734 15.0353 25.4343C15.3066 24.7447 15.4197 24.2812 15.4197 24.2812C15.4197 24.2812 14.8658 24.4169 14.0406 24.7221C13.1928 25.0273 12.1754 25.536 11.1693 26.2595C10.9206 26.4403 10.6606 26.6325 10.4346 26.836C10.2085 27.0394 9.99369 27.2655 9.79022 27.4916C9.38327 27.9551 9.02154 28.4525 8.77285 28.9838C8.54677 29.515 8.42242 30.0802 8.42242 30.6341C8.42242 30.9168 8.44503 31.188 8.53547 31.4707C8.6259 31.7533 8.75024 32.0246 8.9198 32.2958C10.3102 32.1602 11.2824 31.5385 12.1189 30.7472Z"
      fill={color}
    />
    <path
      d="M8.15085 21.998C8.33172 21.7606 8.47867 21.512 8.59171 21.252C8.70475 20.992 8.78388 20.7207 8.8404 20.4381C8.89692 20.1555 8.91953 19.8616 8.95344 19.5677C8.99866 18.9798 8.95344 18.3468 8.85171 17.7025C8.74997 17.0581 8.63693 16.4251 8.47867 15.7695C8.15085 14.4808 7.78912 13.2713 7.47261 12.3443C7.15609 11.4174 6.94132 10.8296 6.94132 10.8296C6.94132 10.8296 6.85088 10.9652 6.71523 11.2252C6.57959 11.4852 6.39872 11.8583 6.19525 12.3104C5.76569 13.2148 5.33614 14.5034 5.05353 15.8599C4.94049 16.5495 4.87267 17.2616 4.87267 17.9399C4.86136 18.279 4.90658 18.6294 4.9518 18.9572C4.99701 19.2851 5.06484 19.6129 5.16657 19.9181C5.35874 20.5398 5.60743 21.0824 6.02568 21.5572C6.43263 22.0319 6.94132 22.405 7.56304 22.6763C7.78912 22.4728 7.9926 22.2354 8.15085 21.998Z"
      fill={color}
    />
    <path
      d="M18.8675 17.0914C18.9805 16.9106 19.0484 16.8088 19.0484 16.8088C19.0484 16.8088 18.9014 16.8088 18.6414 16.8201C18.3814 16.8314 18.031 16.8541 17.6014 16.9106C17.1719 16.9671 16.6632 17.0462 16.1206 17.1706C15.8493 17.2384 15.5667 17.3062 15.2841 17.3853C15.0128 17.4758 14.7302 17.5662 14.4476 17.6906C13.8824 17.9166 13.3059 18.1879 12.7972 18.5271C12.2998 18.8662 11.8364 19.2618 11.4633 19.714C11.2712 19.9288 11.1242 20.1775 10.9999 20.4261C10.8755 20.6748 10.7738 20.9348 10.706 21.2061C10.6381 21.4774 10.6042 21.76 10.6042 22.0426C10.6155 22.3365 10.672 22.6304 10.7738 22.9357C11.4407 23.0487 12.0624 23.0148 12.639 22.8904C13.2042 22.7661 13.7581 22.5513 14.2441 22.2687C14.4928 22.1331 14.7189 21.9748 14.945 21.8052C15.058 21.7261 15.1598 21.6357 15.2728 21.5453C15.3858 21.4548 15.4876 21.3644 15.6006 21.274C16.0302 20.9122 16.4032 20.5053 16.7423 20.0983C17.1041 19.7027 17.4319 19.2957 17.7032 18.9114C17.771 18.821 17.8388 18.7192 17.9067 18.6288C17.9745 18.5384 18.0423 18.4479 18.1101 18.3575C18.2345 18.1766 18.3475 18.0184 18.4493 17.8601C18.6075 17.5436 18.7658 17.2836 18.8675 17.0914Z"
      fill={color}
    />
    <path
      d="M11.8364 13.6782C12.413 13.3843 12.8538 12.9999 13.1816 12.5365C13.5321 12.0956 13.7694 11.5756 13.939 10.9991C14.2894 9.86869 14.346 8.52351 14.3347 7.22354C14.3233 6.89572 14.312 6.5679 14.2894 6.25138C14.2781 5.93487 14.2555 5.62966 14.2329 5.32445C14.1877 4.72533 14.1312 4.16013 14.0747 3.68536C13.9729 2.73581 13.8712 2.10278 13.8712 2.10278C13.8712 2.10278 13.7581 2.22713 13.5773 2.44191C13.3851 2.65668 13.1251 2.96189 12.8312 3.36884C12.5373 3.76448 12.1982 4.22795 11.8817 4.77055C11.5651 5.31314 11.2373 5.88965 10.9773 6.52268C10.7286 7.15571 10.4913 7.81135 10.3443 8.46699C10.2087 9.14523 10.1295 9.80087 10.1634 10.4339C10.2426 11.7113 10.7513 12.8643 11.8364 13.6782Z"
      fill={color}
    />
    <path
      d="M21.3323 12.9885C21.7732 12.672 22.1801 12.3442 22.5418 12.0277C22.9036 11.7112 23.2427 11.4173 23.5027 11.146C23.7627 10.8747 24.0001 10.6599 24.147 10.5016C24.294 10.3434 24.3731 10.2529 24.3731 10.2529C24.3731 10.2529 23.8079 10.1286 22.9262 10.0382C22.4853 9.99294 21.9766 9.97034 21.4227 9.98164C20.8688 9.98164 20.2584 10.0269 19.6593 10.1173C18.4385 10.2982 17.2176 10.7051 16.2907 11.406C15.8385 11.7677 15.4542 12.1859 15.1829 12.672C14.9342 13.1694 14.8098 13.7346 14.8325 14.3563C16.0872 14.9102 17.2741 14.8537 18.3593 14.5485C18.9132 14.3902 19.4332 14.1642 19.9193 13.8929C20.428 13.6216 20.9028 13.3163 21.3323 12.9885Z"
      fill={color}
    />
    <path
      d="M18.9135 64.3542C22.4859 67.3159 26.8497 69.3393 31.123 71.0688C34.6276 72.4818 39.1157 74.7879 43.683 76.9469C39.5679 78.2243 35.5207 79.2756 32.2535 79.8182C31.8239 79.886 34.0284 82.1242 34.4354 81.9999C38.2226 80.8582 42.0664 79.4791 45.8536 77.953C49.9913 79.8295 54.0724 81.446 57.4413 82.0112C57.8596 82.079 59.1823 79.8295 58.7527 79.7617C55.5647 79.2304 51.8679 78.2808 48.0129 77.0713C54.3663 74.4035 60.4711 71.3853 65.7619 68.5141C71.5049 65.3829 75.8121 60.9517 78.6384 55.0509C81.2612 49.591 83.1152 43.5547 83.3866 37.4844C83.7596 29.0854 80.9447 20.8447 76.5696 13.7571C75.2921 11.6884 73.8563 9.61978 72.2623 7.69809C72.398 7.16679 72.4206 6.64681 72.3302 6.16073C72.2284 5.58422 71.991 5.03032 71.6519 4.53294C70.9848 3.51557 69.9109 2.69037 68.803 2.07995C67.6838 1.46953 66.5306 1.0965 65.6714 0.881719C65.2419 0.779982 64.8801 0.712158 64.6314 0.678245C64.507 0.666941 64.4053 0.655637 64.3487 0.644333C64.2922 0.644333 64.2583 0.644333 64.2583 0.644333C64.2583 0.644333 64.2696 0.666941 64.2922 0.734766C64.3261 0.791286 64.3601 0.881719 64.4166 0.99476C64.5296 1.20954 64.6879 1.52605 64.9027 1.91039C65.3097 2.66777 65.8749 3.67383 66.5306 4.64598C66.8585 5.14336 67.2316 5.60683 67.6159 6.04769C67.8081 6.26247 68.0116 6.47724 68.2264 6.66941C68.4299 6.86158 68.656 7.05375 68.8821 7.21201C69.3456 7.52852 69.8317 7.78852 70.3857 7.92417C70.804 8.0259 71.2336 8.07112 71.7084 8.04851C74.7608 11.6545 77.2592 15.8483 79.1584 20.0535C81.5777 25.4116 82.8665 31.2445 82.7309 37.1339C82.5839 43.5434 80.4359 50.0545 77.5644 55.7518C75.326 60.183 72.0701 63.8003 67.8986 66.4907C64.1679 68.8984 60.0754 70.7071 56.0169 72.4705C52.9758 73.7931 49.3582 75.1383 45.6953 76.3478C37.8383 73.7253 29.6421 70.1758 23.9556 66.9654C20.9823 65.2924 18.2917 63.2351 16.0646 60.6351C13.8375 58.0352 12.2435 54.9605 10.9547 51.818C8.51281 45.8494 6.96401 39.6774 7.34838 33.2001C7.78928 25.649 10.7625 18.4144 14.9002 12.1406C15.9629 10.5354 17.1047 8.93023 18.3596 7.42679C18.8118 7.4494 19.2301 7.40418 19.637 7.30244C20.1797 7.16679 20.6771 6.9068 21.1406 6.59029C21.3667 6.43203 21.5928 6.25116 21.7963 6.04769C22.0111 5.85552 22.2146 5.65205 22.4068 5.42596C22.7912 4.9851 23.1642 4.51033 23.4921 4.02426C24.1478 3.0521 24.713 2.04604 25.12 1.28867C25.3235 0.904327 25.4931 0.587813 25.5948 0.373035C25.6514 0.259994 25.6966 0.180865 25.7192 0.113041C25.7305 0.0339123 25.7418 0 25.7418 0C25.7418 0 25.7079 0 25.6514 0C25.5835 0.0113041 25.4931 0.0226082 25.3687 0.0339123C25.12 0.0678245 24.7583 0.135649 24.3287 0.237386C23.4695 0.44086 22.3163 0.825199 21.1971 1.43562C20.0892 2.04604 19.0153 2.87124 18.3483 3.88861C18.0091 4.38599 17.7717 4.93989 17.6699 5.5164C17.5795 5.99117 17.6021 6.49985 17.7265 7.03114C14.8098 10.5015 12.3905 14.4918 10.5251 18.4935C8.20757 23.4447 6.81704 28.7915 6.60224 34.2514C6.36484 40.5252 8.07191 46.5389 10.4234 52.2927C12.3339 56.9274 15.0359 61.1325 18.9135 64.3542Z"
      fill={color}
    />
    <path
      d="M64.8689 75.7486C66.3046 75.5 67.6273 75.0478 68.577 74.6295C69.5266 74.2226 70.1258 73.8835 70.1258 73.8835C70.1258 73.8835 69.5153 73.6461 68.5883 73.3296C67.6612 73.0131 66.4177 72.6174 65.095 72.3009C63.7836 71.9844 62.4157 71.747 61.1608 71.8035C60.5277 71.8261 59.9285 71.9392 59.352 72.1426C58.7754 72.3574 58.2328 72.6739 57.6336 73.1148C58.018 74.4261 59.1711 75.2513 60.5164 75.6356C61.8843 76.0313 63.4444 75.9973 64.8689 75.7486Z"
      fill={color}
    />
    <path
      d="M57.8142 71.0465C58.3907 70.9334 58.9333 70.6621 59.4194 70.3004C60.3916 69.5656 61.1376 68.4465 61.6463 67.3048C62.155 66.1631 62.4376 64.9875 62.5846 64.1058C62.6524 63.6649 62.6976 63.3032 62.7202 63.0432C62.7428 62.7832 62.7428 62.6362 62.7428 62.6362C62.7428 62.6362 62.2907 62.8849 61.6237 63.2919C60.9568 63.7101 60.0751 64.2979 59.2159 64.9988C58.3568 65.6996 57.5203 66.5135 56.9325 67.4631C56.3447 68.4126 55.9717 69.4978 56.0056 70.8656C56.616 71.1369 57.2377 71.1595 57.8142 71.0465Z"
      fill={color}
    />
    <path
      d="M74.5346 66.0382C73.178 66.0834 71.7988 66.1739 70.6117 66.5356C69.4247 66.8973 68.4412 67.5304 67.7855 68.6947C68.5994 69.7912 69.7639 70.2999 71.0752 70.3564C72.3866 70.4242 73.8337 70.0399 75.1677 69.4294C76.5017 68.8303 77.7113 68.0051 78.5592 67.3043C78.9888 66.9652 79.328 66.6373 79.5654 66.4226C79.8028 66.1965 79.9271 66.0608 79.9271 66.0608C79.9271 66.0608 79.2715 66.0495 78.2427 66.0269C77.2252 66.0269 75.8799 66.0043 74.5346 66.0382Z"
      fill={color}
    />
    <path
      d="M65.5018 66.6829C66.7905 66.7507 67.8305 66.129 68.5766 65.1794C69.3226 64.2299 69.7635 62.9751 69.9443 61.743C70.1252 60.5108 70.0687 59.3352 69.9217 58.4761C69.8539 58.0465 69.7861 57.7074 69.7183 57.4587C69.6504 57.2213 69.6165 57.0857 69.6165 57.0857C69.6165 57.0857 69.5374 57.1648 69.4018 57.3118C69.2548 57.4587 69.0626 57.6735 68.8252 57.9448C68.3505 58.4874 67.6948 59.2335 67.0505 60.1152C66.4175 60.9969 65.7844 62.003 65.4227 63.1108C65.061 64.2299 64.9705 65.4281 65.5018 66.6829Z"
      fill={color}
    />
    <path
      d="M83.2955 59.9568C83.4311 59.7985 83.5668 59.629 83.6911 59.4594L83.8833 59.2107L84.0302 59.0072C84.2224 58.7359 84.4033 58.4759 84.5728 58.2159C84.912 57.696 85.2059 57.1986 85.4432 56.769C85.6806 56.3395 85.8728 55.9777 85.9971 55.729C86.1215 55.469 86.178 55.3108 86.178 55.3108C86.178 55.3108 85.5789 55.4917 84.6407 55.7743C83.7137 56.0682 82.5042 56.4977 81.3173 57.0516C81.0233 57.1873 80.7294 57.3342 80.4355 57.4925C80.119 57.6733 79.8251 57.8429 79.5312 58.0238C79.2373 58.2046 78.9434 58.3742 78.6721 58.5664C78.4008 58.7472 78.1295 58.9281 77.8808 59.1316C76.886 59.9116 76.1513 60.8046 75.8461 62.1159C76.9426 62.9297 78.2199 63.0767 79.5425 62.6471C80.8651 62.2515 82.2103 61.2567 83.2955 59.9568Z"
      fill={color}
    />
    <path
      d="M75.3822 54.4745C75.0431 53.2536 74.5457 52.1571 74.1275 51.3771C73.924 50.9815 73.7431 50.665 73.5962 50.4502C73.4492 50.2354 73.3701 50.1111 73.3701 50.1111C73.3701 50.1111 73.3249 50.2354 73.2458 50.4502C73.1553 50.665 73.0197 50.9702 72.884 51.3545C72.7484 51.7389 72.5901 52.1797 72.4545 52.6884C72.3188 53.1745 72.1719 53.7962 72.1267 54.1579C72.0136 55.0284 71.8667 56.0683 71.9232 57.1648C71.991 58.2613 72.2736 59.4144 73.1327 60.4656C74.3762 60.1717 75.1901 59.2448 75.5405 58.1144C75.6196 57.8318 75.6988 57.5379 75.7214 57.2327C75.744 56.9275 75.7553 56.6222 75.744 56.317C75.7214 56.0118 75.6761 55.7066 75.6196 55.4127C75.5405 55.0962 75.4614 54.7797 75.3822 54.4745Z"
      fill={color}
    />
    <path
      d="M89.1627 44.9563C89.2306 44.6737 89.2645 44.5042 89.2645 44.5042C89.2645 44.5042 88.7106 44.7981 87.8401 45.2615C86.981 45.7363 85.8619 46.3919 84.8106 47.1493C83.7141 47.8954 82.629 48.7432 81.9281 49.7266C81.7585 49.9753 81.5777 50.2127 81.4307 50.4727C81.2838 50.7327 81.1707 50.9927 81.0803 51.2753C80.9107 51.8292 80.8542 52.4283 80.9673 53.084C82.2785 53.457 83.4768 53.1744 84.562 52.4735C84.8333 52.304 85.0932 52.1005 85.3532 51.8857C85.6019 51.6709 85.8619 51.4336 86.0767 51.1736C86.5176 50.6536 86.9245 50.0771 87.2862 49.4893C88.0436 48.3249 88.4958 47.0476 88.8123 46.098C88.9706 45.6346 89.0836 45.2389 89.1627 44.9563Z"
      fill={color}
    />
    <path
      d="M77.8468 52.0102C78.3668 51.6484 78.7399 51.185 78.9999 50.6763C79.1242 50.4276 79.2259 50.145 79.2938 49.8737C79.3616 49.5911 79.4181 49.3085 79.4068 49.0033C79.4181 47.805 79.0677 46.539 78.5364 45.4199C77.9712 44.2895 77.2816 43.3173 76.7277 42.6391C76.4451 42.3 76.2191 42.0287 76.0269 41.8478C75.846 41.6669 75.733 41.5652 75.733 41.5652C75.733 41.5652 75.6991 41.6895 75.6652 41.9043C75.6199 42.1191 75.5521 42.4356 75.4843 42.8199C75.3373 43.5886 75.2695 44.6399 75.2017 45.759C75.1791 46.3129 75.2017 46.9007 75.2695 47.4885C75.2921 47.6355 75.3147 47.7824 75.3373 47.9294C75.3599 48.0763 75.3712 48.212 75.4052 48.3589C75.4617 48.6415 75.5295 48.9355 75.6199 49.2067C75.9817 50.3032 76.6599 51.3206 77.8468 52.0102Z"
      fill={color}
    />
    <path
      d="M86.2465 36.7041C86.0205 36.9527 85.8057 37.2014 85.6022 37.4501C85.3987 37.7101 85.1953 37.9588 84.9805 38.2188C84.5848 38.7388 84.2344 39.2814 83.9857 39.824C83.8614 40.0953 83.7596 40.3779 83.6805 40.6605C83.5901 40.9431 83.5222 41.2257 83.4883 41.5083C83.4205 42.0848 83.4883 42.6726 83.7257 43.2943C85.0822 43.4187 86.2126 42.8987 87.1396 41.9944C87.3769 41.7683 87.5917 41.5196 87.8065 41.2596C88.01 40.9883 88.1795 40.7057 88.3491 40.4005C88.6769 39.7901 88.9595 39.1344 89.2082 38.4788C89.3326 38.151 89.423 37.8119 89.5021 37.484C89.5812 37.1562 89.6491 36.8284 89.7056 36.5119C89.8186 35.8789 89.9204 35.291 89.9656 34.7711C90.0221 33.7537 90.0108 33.0754 90.0108 33.0754C90.0108 33.0754 89.5134 33.4937 88.8126 34.1606C88.123 34.8389 87.1396 35.7319 86.2465 36.7041Z"
      fill={color}
    />
    <path
      d="M81.3625 41.0565C81.4416 40.7852 81.4868 40.5026 81.4981 40.22C81.5094 39.9374 81.4642 39.6435 81.4077 39.3496C81.2947 38.7731 81.0912 38.1966 80.8199 37.6427C80.7521 37.507 80.6843 37.3714 80.6051 37.2357C80.526 37.1001 80.4356 36.9644 80.3451 36.8401C80.1643 36.5801 79.9721 36.3314 79.7799 36.0827C79.3843 35.6079 78.9773 35.1671 78.5817 34.7941C78.3895 34.6019 78.186 34.4323 77.9713 34.2741C77.7678 34.1158 77.5756 33.9689 77.3948 33.8445C76.6826 33.3245 76.1739 33.0532 76.1739 33.0532C76.1739 33.0532 76.1626 33.5393 76.253 34.2854C76.2757 34.4662 76.287 34.6697 76.2983 34.8958C76.3096 35.1106 76.3322 35.3366 76.3661 35.5853C76.4113 36.0601 76.5243 36.5801 76.6261 37.1114C76.7165 37.6427 76.8522 38.1966 77.0443 38.7279C77.1348 38.9992 77.2478 39.2592 77.3722 39.5305C77.4852 39.7905 77.5982 40.0505 77.7452 40.2991C78.3104 41.2826 79.1695 42.1417 80.4695 42.5939C80.9329 42.1304 81.2042 41.6104 81.3625 41.0565Z"
      fill={color}
    />
    <path
      d="M83.7823 29.7862C83.6466 30.374 83.6014 30.9506 83.6918 31.5271C83.737 31.8097 83.8275 32.0923 83.9179 32.3636C84.0196 32.6462 84.144 32.9175 84.3248 33.1888C85.67 32.9966 86.71 32.2279 87.3543 31.1201C87.6822 30.5662 87.9422 29.9332 88.1456 29.2662C88.3265 28.5993 88.4169 27.8871 88.4735 27.1863C88.4961 26.8359 88.5187 26.4854 88.53 26.135C88.5187 25.7959 88.5074 25.4681 88.4735 25.1403C88.4282 24.4959 88.3491 23.8968 88.2813 23.3881C88.0778 22.3934 87.8856 21.749 87.8856 21.749C87.8856 21.749 87.5126 22.2803 87.0039 23.1055C86.7552 23.5125 86.4613 23.9872 86.1335 24.5185C85.817 25.0498 85.4892 25.615 85.184 26.2028C84.8901 26.7793 84.5735 27.3898 84.3248 27.9889C84.0875 28.5993 83.9066 29.1984 83.7823 29.7862Z"
      fill={color}
    />
    <path
      d="M81.2041 29.6166C80.9554 29.0853 80.5937 28.5879 80.1868 28.1244C79.9833 27.8983 79.7685 27.6723 79.5424 27.4688C79.3164 27.2653 79.0564 27.0731 78.819 26.8923C77.8129 26.1688 76.7955 25.6601 75.9477 25.3549C75.1225 25.0497 74.5686 24.9141 74.5686 24.9141C74.5686 24.9141 74.6817 25.3775 74.953 26.0671C75.066 26.4175 75.2017 26.8245 75.3825 27.2653C75.473 27.4801 75.5747 27.7062 75.6764 27.9436C75.7895 28.1696 75.8799 28.4183 75.993 28.6557C76.219 29.1305 76.5016 29.6166 76.8181 30.08C77.1121 30.5435 77.4512 30.9957 77.8581 31.3913C78.6946 32.1826 79.6781 32.8043 81.0346 32.94C81.2041 32.6687 81.3285 32.3974 81.4189 32.1261C81.5093 31.8435 81.532 31.5722 81.532 31.2896C81.5546 30.7131 81.4302 30.1479 81.2041 29.6166Z"
      fill={color}
    />
    <path
      d="M83.0586 11.4619C83.0586 11.4619 82.8325 12.0497 82.516 12.9767C82.1995 13.9036 81.8378 15.1131 81.51 16.4018C81.3517 17.0461 81.2387 17.6905 81.1369 18.3235C81.0352 18.9678 80.99 19.6009 81.0352 20.1887C81.0691 20.4826 81.0917 20.7765 81.1482 21.0591C81.2048 21.3417 81.2839 21.613 81.3969 21.873C81.51 22.133 81.6569 22.3817 81.8378 22.6191C82.0073 22.8564 82.1995 23.0938 82.4369 23.3086C83.0699 23.0373 83.5786 22.6643 83.9743 22.1895C84.3812 21.7147 84.6412 21.1608 84.8334 20.5504C84.9238 20.2452 84.9916 19.9174 85.0482 19.5896C85.0934 19.2617 85.1386 18.9113 85.1273 18.5722C85.1273 17.8826 85.0595 17.1818 84.9464 16.4922C84.6751 15.1357 84.2343 13.8471 83.8047 12.9427C83.6012 12.4906 83.4091 12.1176 83.2847 11.8576C83.1491 11.6089 83.0586 11.4619 83.0586 11.4619Z"
      fill={color}
    />
    <path
      d="M79.0107 21.0597C78.8863 20.811 78.7394 20.5623 78.5359 20.3475C78.1516 19.9067 77.6994 19.511 77.202 19.1606C76.6934 18.8215 76.1169 18.5502 75.5516 18.3241C75.269 18.2111 74.9864 18.1093 74.7038 18.0189C74.4212 17.9285 74.1386 17.8606 73.8673 17.8041C73.3247 17.6798 72.8161 17.6006 72.3865 17.5441C71.9569 17.4876 71.6065 17.465 71.3465 17.4537C71.0865 17.4424 70.9396 17.4424 70.9396 17.4424C70.9396 17.4424 70.9961 17.5441 71.1204 17.7363C71.2335 17.9172 71.3804 18.1885 71.5952 18.4937C71.697 18.6519 71.81 18.8102 71.9456 18.991C72.0135 19.0702 72.07 19.1719 72.1491 19.2623C72.2169 19.3528 72.2735 19.4432 72.3413 19.5449C72.6126 19.9293 72.9404 20.3362 73.3021 20.7319C73.6412 21.1388 74.0143 21.5345 74.4438 21.8962C74.5456 21.9866 74.6586 22.0771 74.7717 22.1675C74.8734 22.2579 74.9864 22.3371 75.0995 22.4275C75.3143 22.597 75.5516 22.7553 75.8003 22.891C76.2864 23.1736 76.8403 23.3883 77.4055 23.5127C77.9707 23.637 78.5924 23.6709 79.2707 23.5579C79.3611 23.264 79.4176 22.9588 79.4402 22.6762C79.4402 22.3936 79.4063 22.111 79.3385 21.8397C79.2368 21.5684 79.135 21.3084 79.0107 21.0597Z"
      fill={color}
    />
    <path
      d="M78.1633 14.3109C79.2485 13.497 79.7572 12.3553 79.8364 11.0666C79.8703 10.4336 79.7911 9.76667 79.6555 9.09973C79.5085 8.43278 79.2711 7.78845 79.0111 7.14412C78.7398 6.51109 78.412 5.93458 78.1068 5.39198C77.7903 4.84939 77.4512 4.38592 77.1573 3.99028C76.8747 3.60594 76.6034 3.28942 76.4225 3.07464C76.2303 2.85987 76.1286 2.74683 76.1286 2.74683C76.1286 2.74683 76.0269 3.37986 75.9251 4.31809C75.8686 4.79287 75.8121 5.35807 75.7669 5.95719C75.7443 6.25109 75.7217 6.56761 75.7104 6.88412C75.6991 7.20064 75.6764 7.52846 75.6764 7.85627C75.6651 9.15625 75.7217 10.5014 76.0721 11.6318C76.2303 12.2084 76.479 12.7283 76.8295 13.1692C77.146 13.6327 77.5868 14.017 78.1633 14.3109Z"
      fill={color}
    />
    <path
      d="M73.6974 12.0388C72.7705 11.3493 71.5383 10.931 70.3288 10.7502C69.7297 10.6484 69.1306 10.6145 68.5654 10.6145C68.0115 10.6145 67.5028 10.6371 67.0619 10.671C66.1802 10.7615 65.615 10.8858 65.615 10.8858C65.615 10.8858 65.6941 10.9762 65.8524 11.1345C65.9993 11.2927 66.2254 11.5075 66.4967 11.7788C66.768 12.0501 67.0958 12.344 67.4576 12.6605C67.8193 12.9771 68.2262 13.3049 68.6671 13.6214C69.0967 13.9492 69.5714 14.2431 70.0688 14.5144C70.5549 14.7857 71.0749 15.0118 71.6288 15.1701C72.714 15.4866 73.9009 15.5318 75.1556 14.9892C75.1896 14.3675 75.0539 13.8023 74.8052 13.3049C74.5339 12.8188 74.1496 12.4005 73.6974 12.0388Z"
      fill={color}
    />
    <path
      d="M34.3454 18.8348V9.88115C34.3454 9.79975 34.3997 9.74549 34.481 9.74549H36.8144C38.5238 9.74549 39.2835 10.5323 39.2835 12.1467C39.2835 13.2727 38.9036 13.8425 38.2253 14.1409V14.168C38.9036 14.3715 39.392 15.0227 39.392 16.2572C39.392 18.2922 38.4695 18.9705 36.6652 18.9705H34.481C34.3997 18.9705 34.3454 18.9162 34.3454 18.8348ZM36.2039 13.5304H36.5974C37.2892 13.5304 37.5063 13.2998 37.5063 12.3909C37.5063 11.4955 37.2892 11.2513 36.5974 11.2513H36.2039C36.1497 11.2513 36.1225 11.2785 36.1225 11.3327V13.449C36.1225 13.5033 36.1497 13.5304 36.2039 13.5304ZM36.1225 17.3832C36.1225 17.4375 36.1497 17.4646 36.2039 17.4646H36.5974C37.3435 17.4646 37.6013 17.1662 37.6013 16.1894C37.6013 15.2262 37.3435 14.9413 36.5974 14.9413H36.2039C36.1497 14.9413 36.1225 14.9684 36.1225 15.0227V17.3832ZM40.3866 18.8348V9.88115C40.3866 9.79975 40.4408 9.74549 40.5222 9.74549H44.5514C44.6328 9.74549 44.687 9.79975 44.687 9.88115V11.2106C44.687 11.292 44.6328 11.3463 44.5514 11.3463H42.2451C42.1909 11.3463 42.1637 11.3734 42.1637 11.4277V13.4355C42.1637 13.4897 42.1909 13.5169 42.2451 13.5169H44.2393C44.3207 13.5169 44.375 13.5711 44.375 13.6525V14.982C44.375 15.0634 44.3207 15.1177 44.2393 15.1177H42.2451C42.1909 15.1177 42.1637 15.1448 42.1637 15.1991V17.2883C42.1637 17.3425 42.1909 17.3697 42.2451 17.3697H44.5514C44.6328 17.3697 44.687 17.4239 44.687 17.5053V18.8348C44.687 18.9162 44.6328 18.9705 44.5514 18.9705H40.5222C40.4408 18.9705 40.3866 18.9162 40.3866 18.8348ZM50.4479 16.2301C50.4479 18.1158 49.7289 19.0926 47.8974 19.0926C46.2288 19.0926 45.4284 18.2108 45.4013 16.6235C45.4013 16.5421 45.4284 16.4879 45.5098 16.4743L46.9614 16.2437C47.0563 16.2301 47.1106 16.2708 47.1106 16.3522C47.1377 17.2069 47.3819 17.546 47.911 17.546C48.4129 17.546 48.6436 17.2883 48.6436 16.4472C48.6436 15.6332 48.4808 15.3483 47.7889 15.077L47.2327 14.8599C45.9303 14.358 45.4827 13.6661 45.4827 12.1874C45.4827 10.5188 46.2831 9.62339 47.9246 9.62339C49.5389 9.62339 50.2986 10.4645 50.3665 11.9161C50.3665 11.9975 50.3258 12.0517 50.2444 12.0653L48.8606 12.2824C48.7792 12.2959 48.7114 12.2552 48.7114 12.1738C48.6978 11.5091 48.4672 11.1699 47.9788 11.1699C47.504 11.1699 47.2734 11.4684 47.2734 12.0924C47.2734 12.7843 47.4226 13.0014 48.1416 13.2862L48.6978 13.5033C49.9595 13.9917 50.4479 14.67 50.4479 16.2301ZM54.1261 18.9705H52.6202C52.5388 18.9705 52.4846 18.9162 52.4846 18.8348V11.4277C52.4846 11.3734 52.4574 11.3463 52.4032 11.3463H50.9516C50.8702 11.3463 50.8159 11.292 50.8159 11.2106V9.88115C50.8159 9.79975 50.8702 9.74549 50.9516 9.74549H55.7947C55.8761 9.74549 55.9304 9.79975 55.9304 9.88115V11.2106C55.9304 11.292 55.8761 11.3463 55.7947 11.3463H54.3431C54.2889 11.3463 54.2617 11.3734 54.2617 11.4277V18.8348C54.2617 18.9162 54.2075 18.9705 54.1261 18.9705Z"
      fill={color}
    />
    <path
      d="M22.3958 31.4954V22.5418C22.3958 22.4604 22.4501 22.4061 22.5315 22.4061H26.5606C26.642 22.4061 26.6963 22.4604 26.6963 22.5418V23.8713C26.6963 23.9527 26.642 24.0069 26.5606 24.0069H24.2544C24.2001 24.0069 24.173 24.0341 24.173 24.0883V26.0961C24.173 26.1504 24.2001 26.1775 24.2544 26.1775H26.2486C26.33 26.1775 26.3842 26.2318 26.3842 26.3132V27.6427C26.3842 27.7241 26.33 27.7783 26.2486 27.7783H24.2544C24.2001 27.7783 24.173 27.8055 24.173 27.8597V29.9489C24.173 30.0032 24.2001 30.0303 24.2544 30.0303H26.5606C26.642 30.0303 26.6963 30.0846 26.6963 30.166V31.4954C26.6963 31.5768 26.642 31.6311 26.5606 31.6311H22.5315C22.4501 31.6311 22.3958 31.5768 22.3958 31.4954ZM27.6818 31.4954V22.5418C27.6818 22.4604 27.7361 22.4061 27.8175 22.4061H29.2826C29.4047 22.4061 29.4726 22.4468 29.4997 22.5418L30.9106 27.3849H30.9648L32.3214 22.5418C32.3486 22.4468 32.4164 22.4061 32.5385 22.4061H33.9901C34.0715 22.4061 34.1257 22.4604 34.1257 22.5418V31.4954C34.1257 31.5768 34.0715 31.6311 33.9901 31.6311H32.6742C32.5928 31.6311 32.5385 31.5768 32.5385 31.4954V26.164H32.4571L31.4532 29.8539C31.4261 29.9353 31.3718 29.9896 31.2769 29.9896H30.5307C30.4358 29.9896 30.3815 29.9353 30.3544 29.8539L29.3505 26.164H29.2691V31.4954C29.2691 31.5768 29.2148 31.6311 29.1334 31.6311H27.8175C27.7361 31.6311 27.6818 31.5768 27.6818 31.4954ZM37.0205 31.6311H35.5147C35.4333 31.6311 35.379 31.5768 35.379 31.4954V22.5418C35.379 22.4604 35.4333 22.4061 35.5147 22.4061H37.6853C39.3675 22.4061 40.3985 23.2065 40.3985 25.3093C40.3985 27.3985 39.3268 28.2124 37.6853 28.2124H37.2376C37.1833 28.2124 37.1562 28.2396 37.1562 28.2938V31.4954C37.1562 31.5768 37.1019 31.6311 37.0205 31.6311ZM37.631 26.6523C38.3229 26.6523 38.6213 26.3539 38.6213 25.3093C38.6213 24.2647 38.3229 23.9662 37.631 23.9662H37.2376C37.1833 23.9662 37.1562 23.9934 37.1562 24.0476V26.5709C37.1562 26.6252 37.1833 26.6523 37.2376 26.6523H37.631ZM41.3937 31.4954V22.5418C41.3937 22.4604 41.4479 22.4061 41.5293 22.4061H43.0352C43.1166 22.4061 43.1708 22.4604 43.1708 22.5418V29.9489C43.1708 30.0032 43.198 30.0303 43.2522 30.0303H45.5856C45.667 30.0303 45.7213 30.0846 45.7213 30.166V31.4954C45.7213 31.5768 45.667 31.6311 45.5856 31.6311H41.5293C41.4479 31.6311 41.3937 31.5768 41.3937 31.4954ZM48.697 31.7532C47.4897 31.7532 46.6757 31.2106 46.3365 30.1931C46.1873 29.7725 46.1466 29.3927 46.1466 27.0186C46.1466 24.6445 46.1873 24.2647 46.3365 23.8441C46.6757 22.8267 47.4897 22.284 48.697 22.284C49.9044 22.284 50.7184 22.8267 51.0576 23.8441C51.2068 24.2647 51.2475 24.6445 51.2475 27.0186C51.2475 29.3927 51.2068 29.7725 51.0576 30.1931C50.7184 31.2106 49.9044 31.7532 48.697 31.7532ZM48.697 30.1524C49.0362 30.1524 49.2668 29.9625 49.3482 29.7047C49.416 29.4877 49.4432 29.257 49.4432 27.0186C49.4432 24.7802 49.416 24.5496 49.3482 24.3325C49.2668 24.0748 49.0362 23.8848 48.697 23.8848C48.3579 23.8848 48.1273 24.0748 48.0459 24.3325C47.978 24.5496 47.9509 24.7802 47.9509 27.0186C47.9509 29.257 47.978 29.4877 48.0459 29.7047C48.1273 29.9625 48.3579 30.1524 48.697 30.1524ZM54.9089 31.6311H53.4031C53.3217 31.6311 53.2674 31.5768 53.2674 31.4954V27.9682L51.4767 22.5418C51.4496 22.4604 51.4767 22.4061 51.5852 22.4061H53.0911C53.186 22.4061 53.2403 22.4468 53.2539 22.5418L54.1628 25.9198H54.2171L55.0853 22.5418C55.1124 22.4468 55.1531 22.4061 55.2481 22.4061H56.7268C56.8353 22.4061 56.8625 22.4604 56.8353 22.5418L55.0446 27.9682V31.4954C55.0446 31.5768 54.9903 31.6311 54.9089 31.6311ZM57.5697 31.4954V22.5418C57.5697 22.4604 57.624 22.4061 57.7054 22.4061H61.7345C61.8159 22.4061 61.8702 22.4604 61.8702 22.5418V23.8713C61.8702 23.9527 61.8159 24.0069 61.7345 24.0069H59.4283C59.374 24.0069 59.3469 24.0341 59.3469 24.0883V26.0961C59.3469 26.1504 59.374 26.1775 59.4283 26.1775H61.4225C61.5039 26.1775 61.5582 26.2318 61.5582 26.3132V27.6427C61.5582 27.7241 61.5039 27.7783 61.4225 27.7783H59.4283C59.374 27.7783 59.3469 27.8055 59.3469 27.8597V29.9489C59.3469 30.0032 59.374 30.0303 59.4283 30.0303H61.7345C61.8159 30.0303 61.8702 30.0846 61.8702 30.166V31.4954C61.8702 31.5768 61.8159 31.6311 61.7345 31.6311H57.7054C57.624 31.6311 57.5697 31.5768 57.5697 31.4954ZM62.8557 31.4954V22.5418C62.8557 22.4604 62.91 22.4061 62.9914 22.4061H67.0205C67.1019 22.4061 67.1562 22.4604 67.1562 22.5418V23.8713C67.1562 23.9527 67.1019 24.0069 67.0205 24.0069H64.7143C64.66 24.0069 64.6329 24.0341 64.6329 24.0883V26.0961C64.6329 26.1504 64.66 26.1775 64.7143 26.1775H66.7085C66.7899 26.1775 66.8442 26.2318 66.8442 26.3132V27.6427C66.8442 27.7241 66.7899 27.7783 66.7085 27.7783H64.7143C64.66 27.7783 64.6329 27.8055 64.6329 27.8597V29.9489C64.6329 30.0032 64.66 30.0303 64.7143 30.0303H67.0205C67.1019 30.0303 67.1562 30.0846 67.1562 30.166V31.4954C67.1562 31.5768 67.1019 31.6311 67.0205 31.6311H62.9914C62.91 31.6311 62.8557 31.5768 62.8557 31.4954Z"
      fill={color}
    />
    <path
      d="M32.5433 44.4136C31.3359 44.4136 30.5219 43.871 30.1828 42.8535C30.0336 42.4329 29.9929 42.0531 29.9929 39.679C29.9929 37.3049 30.0336 36.9251 30.1828 36.5045C30.5219 35.4871 31.3359 34.9444 32.5433 34.9444C33.7507 34.9444 34.5647 35.4871 34.9038 36.5045C35.053 36.9251 35.0937 37.3049 35.0937 39.679C35.0937 42.0531 35.053 42.4329 34.9038 42.8535C34.5647 43.871 33.7507 44.4136 32.5433 44.4136ZM32.5433 42.8128C32.8825 42.8128 33.1131 42.6229 33.1945 42.3651C33.2623 42.1481 33.2894 41.9174 33.2894 39.679C33.2894 37.4406 33.2623 37.21 33.1945 36.9929C33.1131 36.7352 32.8825 36.5452 32.5433 36.5452C32.2041 36.5452 31.9735 36.7352 31.8921 36.9929C31.8243 37.21 31.7972 37.4406 31.7972 39.679C31.7972 41.9174 31.8243 42.1481 31.8921 42.3651C31.9735 42.6229 32.2041 42.8128 32.5433 42.8128ZM36.2094 44.1558V35.2022C36.2094 35.1208 36.2637 35.0665 36.3451 35.0665H40.3742C40.4556 35.0665 40.5099 35.1208 40.5099 35.2022V36.5317C40.5099 36.6131 40.4556 36.6673 40.3742 36.6673H38.068C38.0137 36.6673 37.9866 36.6945 37.9866 36.7487V38.8379C37.9866 38.8922 38.0137 38.9193 38.068 38.9193H40.0622C40.1436 38.9193 40.1979 38.9736 40.1979 39.055V40.398C40.1979 40.4794 40.1436 40.5337 40.0622 40.5337H38.068C38.0137 40.5337 37.9866 40.5608 37.9866 40.6151V44.1558C37.9866 44.2372 37.9323 44.2915 37.8509 44.2915H36.3451C36.2637 44.2915 36.2094 44.2372 36.2094 44.1558ZM46.8356 44.2915H45.3298C45.2484 44.2915 45.1941 44.2372 45.1941 44.1558V36.7487C45.1941 36.6945 45.167 36.6673 45.1127 36.6673H43.6612C43.5798 36.6673 43.5255 36.6131 43.5255 36.5317V35.2022C43.5255 35.1208 43.5798 35.0665 43.6612 35.0665H48.5043C48.5857 35.0665 48.6399 35.1208 48.6399 35.2022V36.5317C48.6399 36.6131 48.5857 36.6673 48.5043 36.6673H47.0527C46.9984 36.6673 46.9713 36.6945 46.9713 36.7487V44.1558C46.9713 44.2372 46.917 44.2915 46.8356 44.2915ZM49.4576 44.1558V35.2022C49.4576 35.1208 49.5119 35.0665 49.5933 35.0665H51.0991C51.1805 35.0665 51.2348 35.1208 51.2348 35.2022V38.7023C51.2348 38.7565 51.2619 38.7837 51.3162 38.7837H52.605C52.6592 38.7837 52.6864 38.7565 52.6864 38.7023V35.2022C52.6864 35.1208 52.7406 35.0665 52.822 35.0665H54.3279C54.4093 35.0665 54.4635 35.1208 54.4635 35.2022V44.1558C54.4635 44.2372 54.4093 44.2915 54.3279 44.2915H52.822C52.7406 44.2915 52.6864 44.2372 52.6864 44.1558V40.4659C52.6864 40.4116 52.6592 40.3845 52.605 40.3845H51.3162C51.2619 40.3845 51.2348 40.4116 51.2348 40.4659V44.1558C51.2348 44.2372 51.1805 44.2915 51.0991 44.2915H49.5933C49.5119 44.2915 49.4576 44.2372 49.4576 44.1558ZM55.7108 44.1558V35.2022C55.7108 35.1208 55.765 35.0665 55.8464 35.0665H59.8756C59.957 35.0665 60.0112 35.1208 60.0112 35.2022V36.5317C60.0112 36.6131 59.957 36.6673 59.8756 36.6673H57.5693C57.5151 36.6673 57.4879 36.6945 57.4879 36.7487V38.7565C57.4879 38.8108 57.5151 38.8379 57.5693 38.8379H59.5635C59.6449 38.8379 59.6992 38.8922 59.6992 38.9736V40.3031C59.6992 40.3845 59.6449 40.4387 59.5635 40.4387H57.5693C57.5151 40.4387 57.4879 40.4659 57.4879 40.5201V42.6093C57.4879 42.6636 57.5151 42.6907 57.5693 42.6907H59.8756C59.957 42.6907 60.0112 42.745 60.0112 42.8264V44.1558C60.0112 44.2372 59.957 44.2915 59.8756 44.2915H55.8464C55.765 44.2915 55.7108 44.2372 55.7108 44.1558Z"
      fill={color}
    />
    <path
      d="M29.6537 56.8167V47.8631C29.6537 47.7817 29.708 47.7274 29.7894 47.7274H31.2545C31.3766 47.7274 31.4445 47.7681 31.4716 47.8631L32.8825 52.7062H32.9367L34.2934 47.8631C34.3205 47.7681 34.3883 47.7274 34.5104 47.7274H35.962C36.0434 47.7274 36.0977 47.7817 36.0977 47.8631V56.8167C36.0977 56.8981 36.0434 56.9524 35.962 56.9524H34.6461C34.5647 56.9524 34.5104 56.8981 34.5104 56.8167V51.4852H34.429L33.4251 55.1752C33.398 55.2566 33.3437 55.3109 33.2488 55.3109H32.5026C32.4077 55.3109 32.3534 55.2566 32.3263 55.1752L31.3224 51.4852H31.241V56.8167C31.241 56.8981 31.1867 56.9524 31.1053 56.9524H29.7894C29.708 56.9524 29.6537 56.8981 29.6537 56.8167ZM39.7657 57.0745C38.5583 57.0745 37.7443 56.5318 37.4052 55.5144C37.256 55.0938 37.2153 54.714 37.2153 52.3399C37.2153 49.9658 37.256 49.586 37.4052 49.1654C37.7443 48.148 38.5583 47.6053 39.7657 47.6053C40.9731 47.6053 41.7871 48.148 42.1262 49.1654C42.2754 49.586 42.3161 49.9658 42.3161 52.3399C42.3161 54.714 42.2754 55.0938 42.1262 55.5144C41.7871 56.5318 40.9731 57.0745 39.7657 57.0745ZM39.7657 55.4737C40.1049 55.4737 40.3355 55.2838 40.4169 55.026C40.4847 54.8089 40.5118 54.5783 40.5118 52.3399C40.5118 50.1015 40.4847 49.8709 40.4169 49.6538C40.3355 49.3961 40.1049 49.2061 39.7657 49.2061C39.4265 49.2061 39.1959 49.3961 39.1145 49.6538C39.0467 49.8709 39.0196 50.1015 39.0196 52.3399C39.0196 54.5783 39.0467 54.8089 39.1145 55.026C39.1959 55.2838 39.4265 55.4737 39.7657 55.4737ZM43.4318 56.8167V47.8631C43.4318 47.7817 43.4861 47.7274 43.5675 47.7274H45.2633C45.3718 47.7274 45.4261 47.7681 45.4532 47.8631L46.9862 53.6558H47.054V47.8631C47.054 47.7817 47.1083 47.7274 47.1897 47.7274H48.4784C48.5598 47.7274 48.6141 47.7817 48.6141 47.8631V56.8167C48.6141 56.8981 48.5598 56.9524 48.4784 56.9524H46.8505C46.742 56.9524 46.6877 56.9117 46.6606 56.8167L45.0598 51.024H44.992V56.8167C44.992 56.8981 44.9377 56.9524 44.8563 56.9524H43.5675C43.4861 56.9524 43.4318 56.8981 43.4318 56.8167ZM52.7332 56.9524H51.2274C51.146 56.9524 51.0917 56.8981 51.0917 56.8167V49.4096C51.0917 49.3554 51.0646 49.3282 51.0103 49.3282H49.5588C49.4774 49.3282 49.4231 49.274 49.4231 49.1926V47.8631C49.4231 47.7817 49.4774 47.7274 49.5588 47.7274H54.4019C54.4833 47.7274 54.5375 47.7817 54.5375 47.8631V49.1926C54.5375 49.274 54.4833 49.3282 54.4019 49.3282H52.9503C52.896 49.3282 52.8689 49.3554 52.8689 49.4096V56.8167C52.8689 56.8981 52.8146 56.9524 52.7332 56.9524ZM55.3552 56.8167V47.8631C55.3552 47.7817 55.4095 47.7274 55.4909 47.7274H56.9967C57.0781 47.7274 57.1324 47.7817 57.1324 47.8631V51.3631C57.1324 51.4174 57.1595 51.4445 57.2138 51.4445H58.5025C58.5568 51.4445 58.5839 51.4174 58.5839 51.3631V47.8631C58.5839 47.7817 58.6382 47.7274 58.7196 47.7274H60.2254C60.3068 47.7274 60.3611 47.7817 60.3611 47.8631V56.8167C60.3611 56.8981 60.3068 56.9524 60.2254 56.9524H58.7196C58.6382 56.9524 58.5839 56.8981 58.5839 56.8167V53.1267C58.5839 53.0725 58.5568 53.0453 58.5025 53.0453H57.2138C57.1595 53.0453 57.1324 53.0725 57.1324 53.1267V56.8167C57.1324 56.8981 57.0781 56.9524 56.9967 56.9524H55.4909C55.4095 56.9524 55.3552 56.8981 55.3552 56.8167Z"
      fill={color}
    />
  </svg>
);

const SvgTwo = ({ color = "#000" }) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 91 82"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.7997 72.482C32.2005 72.0411 31.6579 71.7133 31.0813 71.5098C30.5048 71.3064 29.9056 71.1933 29.2725 71.1707C28.0176 71.1142 26.6497 71.3516 25.3383 71.6681C24.0269 71.9959 22.7834 72.3802 21.845 72.6968C20.918 73.002 20.3188 73.2507 20.3188 73.2507C20.3188 73.2507 20.9067 73.5898 21.8676 73.9967C22.8173 74.4037 24.14 74.8671 25.5757 75.1158C27.0002 75.3645 28.5603 75.3984 29.9282 75.0028C31.2735 74.6298 32.4266 73.7933 32.7997 72.482Z"
      fill={color}
    />
    <path
      d="M28.7976 66.6712C29.3063 67.8129 30.0523 68.932 31.0245 69.6668C31.5106 70.0285 32.0532 70.2998 32.6297 70.4129C33.2062 70.5259 33.8279 70.492 34.4383 70.2433C34.4722 68.8755 34.0992 67.7903 33.5114 66.8408C32.9236 65.9025 32.0871 65.0886 31.228 64.3765C30.3688 63.6756 29.4871 63.0878 28.8202 62.6696C28.1532 62.2513 27.7011 62.0139 27.7011 62.0139C27.7011 62.0139 27.7124 62.1609 27.735 62.4209C27.7576 62.6696 27.8028 63.0426 27.8706 63.4834C28.0063 64.3539 28.2889 65.5295 28.7976 66.6712Z"
      fill={color}
    />
    <path
      d="M19.3692 69.7348C20.6806 69.667 21.845 69.1696 22.659 68.0731C22.0033 66.9088 21.0198 66.2758 19.8327 65.914C18.6457 65.5523 17.2665 65.4506 15.9098 65.4054C14.5532 65.3714 13.2079 65.3941 12.2018 65.4054C11.173 65.4167 10.5173 65.4393 10.5173 65.4393C10.5173 65.4393 10.653 65.5636 10.8791 65.801C11.1165 66.0158 11.4556 66.3323 11.8852 66.6827C12.7331 67.3836 13.9428 68.2088 15.2768 68.8079C16.5995 69.407 18.0578 69.7913 19.3692 69.7348Z"
      fill={color}
    />
    <path
      d="M21.8675 64.5464C22.6136 65.4846 23.6536 66.1063 24.9422 66.0498C25.4735 64.7838 25.3831 63.5855 25.0214 62.4777C24.6596 61.3812 24.0379 60.3639 23.3936 59.4821C22.7492 58.6004 22.1049 57.8543 21.6188 57.3118C21.3814 57.0405 21.178 56.8257 21.0423 56.6787C20.9067 56.5318 20.8275 56.4526 20.8275 56.4526C20.8275 56.4526 20.7823 56.5883 20.7145 56.8257C20.6467 57.0744 20.5788 57.4135 20.511 57.843C20.3754 58.7022 20.3075 59.8778 20.4884 61.1099C20.6806 62.3421 21.1214 63.5968 21.8675 64.5464Z"
      fill={color}
    />
    <path
      d="M5.80289 55.1412C4.87595 54.8473 4.26553 54.6777 4.26553 54.6777C4.26553 54.6777 4.32205 54.836 4.43509 55.096C4.55944 55.356 4.75161 55.7177 4.989 56.136C5.22638 56.5655 5.52029 57.0629 5.85941 57.5829C6.02897 57.8429 6.20984 58.1142 6.40201 58.3742L6.54896 58.5776L6.74113 58.8263C6.86547 58.9959 7.00112 59.1542 7.13677 59.3237C8.22196 60.6237 9.56715 61.6071 10.8897 62.0254C12.2123 62.4436 13.4897 62.308 14.5862 61.4941C14.281 60.1828 13.5462 59.2898 12.5514 58.5098C12.3027 58.3177 12.0314 58.1368 11.7601 57.9446C11.4888 57.7524 11.1949 57.5829 10.901 57.402C10.6071 57.2212 10.3019 57.0403 9.99671 56.8707C9.7028 56.7125 9.40889 56.5655 9.11499 56.4299C7.93936 55.8647 6.72982 55.4351 5.80289 55.1412Z"
      fill={color}
    />
    <path
      d="M14.915 57.4697C15.2654 58.6001 16.0793 59.527 17.3227 59.8209C18.1819 58.7583 18.4645 57.6053 18.5323 56.5088C18.5888 55.4123 18.4532 54.3837 18.3288 53.5132C18.2836 53.1402 18.1366 52.5185 18.001 52.0324C17.8653 51.535 17.7071 51.0829 17.5714 50.6985C17.4358 50.3142 17.3001 50.009 17.2097 49.7942C17.1306 49.5794 17.0741 49.4551 17.0741 49.4551C17.0741 49.4551 16.9836 49.5794 16.848 49.7942C16.701 50.0203 16.5202 50.3368 16.3167 50.7324C15.9097 51.5124 15.4124 52.6202 15.0732 53.8411C14.9828 54.1463 14.9037 54.4515 14.8471 54.7793C14.7906 55.0732 14.7454 55.3671 14.7228 55.6836C14.7002 55.9888 14.7228 56.2941 14.7454 56.5993C14.7567 56.8932 14.8358 57.1871 14.915 57.4697Z"
      fill={color}
    />
    <path
      d="M4.37827 50.5402C4.59305 50.8002 4.84174 51.0376 5.10174 51.2523C5.35043 51.4671 5.62172 51.6706 5.89302 51.8402C6.97822 52.541 8.17645 52.8236 9.48772 52.4506C9.60076 51.7949 9.54424 51.1958 9.37468 50.6419C9.28425 50.3706 9.17121 50.0993 9.02426 49.8506C8.8773 49.5906 8.70774 49.3533 8.53818 49.1046C7.83733 48.1324 6.75213 47.2846 5.65564 46.5272C4.59305 45.7699 3.47395 45.1142 2.61484 44.6395C1.74442 44.176 1.19052 43.8821 1.19052 43.8821C1.19052 43.8821 1.21313 44.0403 1.28095 44.3229C1.36008 44.6055 1.47312 45.0012 1.64268 45.476C1.9705 46.4255 2.42267 47.7029 3.16874 48.8672C3.53047 49.455 3.93741 50.0315 4.37827 50.5402Z"
      fill={color}
    />
    <path
      d="M11.4556 50.0317C11.7156 50.5404 12.0886 51.0039 12.6086 51.3656C13.7955 50.6874 14.4737 49.67 14.8355 48.5622C14.9259 48.2909 14.9937 48.0083 15.0503 47.7144C15.0842 47.5675 15.0955 47.4318 15.1181 47.2849C15.1407 47.1379 15.1633 46.9909 15.1859 46.844C15.265 46.2562 15.2763 45.6797 15.265 45.1145C15.1972 43.9954 15.1181 42.9441 14.9824 42.1754C14.9146 41.7911 14.8468 41.4746 14.8016 41.2598C14.7677 41.045 14.745 40.9207 14.745 40.9207C14.745 40.9207 14.632 41.0224 14.4511 41.2033C14.259 41.3841 14.0216 41.6554 13.7503 41.9945C13.1964 42.6728 12.5068 43.6449 11.9416 44.7753C11.4103 45.8945 11.0599 47.1605 11.0712 48.3587C11.0712 48.664 11.1164 48.9466 11.1843 49.2292C11.2295 49.5118 11.3199 49.7831 11.4556 50.0317Z"
      fill={color}
    />
    <path
      d="M2.09481 39.7677C2.26437 40.0729 2.43393 40.3668 2.63741 40.6268C2.84088 40.8981 3.06696 41.1468 3.30435 41.3616C4.24259 42.2659 5.36169 42.7859 6.71818 42.6615C6.95557 42.0398 7.02339 41.452 6.95557 40.8755C6.92166 40.5929 6.85383 40.3103 6.7634 40.0277C6.67297 39.7451 6.58253 39.4738 6.45819 39.2025C6.2095 38.6486 5.85907 38.1173 5.46343 37.5973C5.25995 37.3373 5.04518 37.0773 4.85301 36.8286C4.64953 36.5686 4.42345 36.3199 4.20867 36.0825C3.32696 35.0991 2.3435 34.2061 1.65395 33.5391C0.941793 32.8609 0.444413 32.4426 0.444413 32.4426C0.444413 32.4426 0.421805 33.1209 0.48963 34.1382C0.523542 34.6469 0.625279 35.2347 0.749624 35.8678C0.806144 36.1843 0.885273 36.5121 0.964401 36.8399C1.04353 37.1677 1.12266 37.5069 1.25831 37.8347C1.48439 38.5016 1.76699 39.1573 2.09481 39.7677Z"
      fill={color}
    />
    <path
      d="M9.95192 41.9379C11.2519 41.497 12.111 40.6379 12.6762 39.6431C12.8232 39.3944 12.9362 39.1458 13.0492 38.8745C13.1736 38.6145 13.2866 38.3432 13.3771 38.0719C13.5692 37.5293 13.7049 36.9867 13.7953 36.4554C13.897 35.9241 14.0101 35.4041 14.0553 34.9293C14.0892 34.6806 14.1118 34.4546 14.1231 34.2398C14.1344 34.025 14.1457 33.8215 14.1683 33.6294C14.2475 32.8833 14.2362 32.3972 14.2362 32.3972C14.2362 32.3972 13.7388 32.6685 13.0153 33.1885C12.8345 33.3128 12.6423 33.4598 12.4388 33.6181C12.2353 33.7763 12.0319 33.9572 11.8284 34.138C11.4328 34.5111 11.0145 34.9519 10.6302 35.4267C10.438 35.6641 10.2458 35.9128 10.065 36.1841C9.97453 36.3084 9.88409 36.4441 9.80497 36.5797C9.72584 36.7154 9.65801 36.851 9.59019 36.9867C9.31889 37.5406 9.11542 38.1171 9.00238 38.7049C8.94586 38.9988 8.91194 39.2814 8.92325 39.5753C8.93455 39.8579 8.97977 40.1405 9.0589 40.4118C9.23976 40.977 9.51106 41.4857 9.95192 41.9379Z"
      fill={color}
    />
    <path
      d="M5.24875 25.5695C4.94354 24.9817 4.61572 24.4165 4.29921 23.8965C3.97139 23.3652 3.67748 22.8792 3.42879 22.4722C2.92011 21.6583 2.54707 21.1157 2.54707 21.1157C2.54707 21.1157 2.3549 21.7601 2.15143 22.7548C2.0723 23.2635 2.00448 23.8513 1.95926 24.4956C1.93665 24.8235 1.91404 25.1513 1.90274 25.4904C1.90274 25.8295 1.92535 26.18 1.95926 26.5304C2.01578 27.2312 2.10621 27.9434 2.28708 28.6103C2.49055 29.2773 2.75055 29.9216 3.07837 30.4642C3.7227 31.572 4.76268 32.3407 6.10786 32.5329C6.28873 32.2616 6.41307 31.979 6.51481 31.7077C6.60524 31.4251 6.70698 31.1538 6.74089 30.8712C6.83132 30.3059 6.78611 29.7181 6.65046 29.1303C6.53742 28.5425 6.35655 27.9434 6.09656 27.3443C5.84787 26.7678 5.54266 26.1573 5.24875 25.5695Z"
      fill={color}
    />
    <path
      d="M12.5632 30.7472C12.9701 30.3515 13.3092 29.8994 13.6031 29.4359C13.9197 28.9724 14.2023 28.4977 14.4283 28.0116C14.5414 27.7742 14.6318 27.5368 14.7449 27.2994C14.8579 27.0734 14.9596 26.8473 15.0501 26.6212C15.2309 26.1803 15.3666 25.7734 15.4796 25.4343C15.7509 24.7447 15.864 24.2812 15.864 24.2812C15.864 24.2812 15.3101 24.4169 14.4849 24.7221C13.6371 25.0273 12.6197 25.536 11.6136 26.2595C11.3649 26.4403 11.1049 26.6325 10.8789 26.836C10.6528 27.0394 10.438 27.2655 10.2345 27.4916C9.82758 27.9551 9.46585 28.4525 9.21716 28.9838C8.99108 29.515 8.86673 30.0802 8.86673 30.6341C8.86673 30.9168 8.88934 31.188 8.97977 31.4707C9.0702 31.7533 9.19455 32.0246 9.36411 32.2958C10.7545 32.1602 11.7267 31.5385 12.5632 30.7472Z"
      fill={color}
    />
    <path
      d="M8.59516 21.998C8.77602 21.7606 8.92298 21.512 9.03602 21.252C9.14906 20.992 9.22819 20.7207 9.28471 20.4381C9.34123 20.1555 9.36384 19.8616 9.39775 19.5677C9.44297 18.9798 9.39775 18.3468 9.29601 17.7025C9.19428 17.0581 9.08123 16.4251 8.92298 15.7695C8.59516 14.4808 8.23343 13.2713 7.91691 12.3443C7.6004 11.4174 7.38562 10.8296 7.38562 10.8296C7.38562 10.8296 7.29519 10.9652 7.15954 11.2252C7.02389 11.4852 6.84302 11.8583 6.63955 12.3104C6.21 13.2148 5.78044 14.5034 5.49784 15.8599C5.3848 16.5495 5.31697 17.2616 5.31697 17.9399C5.30567 18.279 5.35089 18.6294 5.3961 18.9572C5.44132 19.2851 5.50914 19.6129 5.61088 19.9181C5.80305 20.5398 6.05174 21.0824 6.46999 21.5572C6.87694 22.0319 7.38562 22.405 8.00735 22.6763C8.23343 22.4728 8.4369 22.2354 8.59516 21.998Z"
      fill={color}
    />
    <path
      d="M19.3119 17.0914C19.4249 16.9106 19.4928 16.8088 19.4928 16.8088C19.4928 16.8088 19.3458 16.8088 19.0858 16.8201C18.8258 16.8314 18.4754 16.8541 18.0458 16.9106C17.6163 16.9671 17.1076 17.0462 16.565 17.1706C16.2937 17.2384 16.0111 17.3062 15.7285 17.3853C15.4572 17.4758 15.1746 17.5662 14.892 17.6906C14.3268 17.9166 13.7503 18.1879 13.2416 18.5271C12.7442 18.8662 12.2808 19.2618 11.9077 19.714C11.7156 19.9288 11.5686 20.1775 11.4443 20.4261C11.3199 20.6748 11.2182 20.9348 11.1504 21.2061C11.0825 21.4774 11.0486 21.76 11.0486 22.0426C11.0599 22.3365 11.1164 22.6304 11.2182 22.9357C11.8851 23.0487 12.5068 23.0148 13.0834 22.8904C13.6486 22.7661 14.2025 22.5513 14.6885 22.2687C14.9372 22.1331 15.1633 21.9748 15.3894 21.8052C15.5024 21.7261 15.6042 21.6357 15.7172 21.5453C15.8302 21.4548 15.932 21.3644 16.045 21.274C16.4746 20.9122 16.8476 20.5053 17.1867 20.0983C17.5485 19.7027 17.8763 19.2957 18.1476 18.9114C18.2154 18.821 18.2832 18.7192 18.3511 18.6288C18.4189 18.5384 18.4867 18.4479 18.5545 18.3575C18.6789 18.1766 18.7919 18.0184 18.8937 17.8601C19.0519 17.5436 19.2102 17.2836 19.3119 17.0914Z"
      fill={color}
    />
    <path
      d="M12.2808 13.6782C12.8573 13.3843 13.2981 12.9999 13.6259 12.5365C13.9764 12.0956 14.2138 11.5756 14.3833 10.9991C14.7337 9.86869 14.7903 8.52351 14.779 7.22354C14.7677 6.89572 14.7563 6.5679 14.7337 6.25138C14.7224 5.93487 14.6998 5.62966 14.6772 5.32445C14.632 4.72533 14.5755 4.16013 14.519 3.68536C14.4172 2.73581 14.3155 2.10278 14.3155 2.10278C14.3155 2.10278 14.2024 2.22713 14.0216 2.44191C13.8294 2.65668 13.5694 2.96189 13.2755 3.36884C12.9816 3.76448 12.6425 4.22795 12.326 4.77055C12.0095 5.31314 11.6816 5.88965 11.4216 6.52268C11.173 7.15571 10.9356 7.81135 10.7886 8.46699C10.653 9.14523 10.5738 9.80087 10.6077 10.4339C10.6869 11.7113 11.1956 12.8643 12.2808 13.6782Z"
      fill={color}
    />
    <path
      d="M21.7766 12.9885C22.2175 12.672 22.6244 12.3442 22.9861 12.0277C23.3479 11.7112 23.687 11.4173 23.947 11.146C24.207 10.8747 24.4444 10.6599 24.5913 10.5016C24.7383 10.3434 24.8174 10.2529 24.8174 10.2529C24.8174 10.2529 24.2522 10.1286 23.3705 10.0382C22.9296 9.99294 22.4209 9.97034 21.867 9.98164C21.3131 9.98164 20.7027 10.0269 20.1036 10.1173C18.8828 10.2982 17.6619 10.7051 16.735 11.406C16.2828 11.7677 15.8985 12.1859 15.6272 12.672C15.3785 13.1694 15.2542 13.7346 15.2768 14.3563C16.5315 14.9102 17.7184 14.8537 18.8036 14.5485C19.3575 14.3902 19.8775 14.1642 20.3636 13.8929C20.8723 13.6216 21.3471 13.3163 21.7766 12.9885Z"
      fill={color}
    />
    <path
      d="M19.3579 64.3542C22.9304 67.3159 27.2941 69.3393 31.5675 71.0688C35.072 72.4818 39.5602 74.7879 44.1274 76.9469C40.0124 78.2243 35.9651 79.2756 32.698 79.8182C32.2684 79.886 34.4729 82.1242 34.8799 81.9999C38.6671 80.8582 42.5108 79.4791 46.298 77.953C50.4357 79.8295 54.5168 81.446 57.8858 82.0112C58.3041 82.079 59.6267 79.8295 59.1972 79.7617C56.0091 79.2304 52.3123 78.2808 48.4573 77.0713C54.8108 74.4035 60.9155 71.3853 66.2063 68.5141C71.9493 65.3829 76.2566 60.9517 79.0828 55.0509C81.7056 49.591 83.5597 43.5547 83.831 37.4844C84.2041 29.0854 81.3891 20.8447 77.014 13.7571C75.7365 11.6884 74.3008 9.61978 72.7068 7.69809C72.8424 7.16679 72.865 6.64681 72.7746 6.16073C72.6728 5.58422 72.4354 5.03032 72.0963 4.53294C71.4293 3.51557 70.3553 2.69037 69.2474 2.07995C68.1282 1.46953 66.9751 1.0965 66.1159 0.881719C65.6863 0.779982 65.3245 0.712158 65.0758 0.678245C64.9515 0.666941 64.8497 0.655637 64.7932 0.644333C64.7367 0.644333 64.7027 0.644333 64.7027 0.644333C64.7027 0.644333 64.714 0.666941 64.7367 0.734766C64.7706 0.791286 64.8045 0.881719 64.861 0.99476C64.9741 1.20954 65.1323 1.52605 65.3471 1.91039C65.7541 2.66777 66.3194 3.67383 66.9751 4.64598C67.3029 5.14336 67.676 5.60683 68.0604 6.04769C68.2525 6.26247 68.456 6.47724 68.6708 6.66941C68.8743 6.86158 69.1004 7.05375 69.3265 7.21201C69.79 7.52852 70.2762 7.78852 70.8301 7.92417C71.2484 8.0259 71.678 8.07112 72.1528 8.04851C75.2052 11.6545 77.7036 15.8483 79.6029 20.0535C82.0222 25.4116 83.311 31.2445 83.1753 37.1339C83.0283 43.5434 80.8804 50.0545 78.0089 55.7518C75.7704 60.183 72.5146 63.8003 68.343 66.4907C64.6123 68.8984 60.5199 70.7071 56.4613 72.4705C53.4202 73.7931 49.8026 75.1383 46.1397 76.3478C38.2827 73.7253 30.0865 70.1758 24.4 66.9654C21.4268 65.2924 18.7362 63.2351 16.5091 60.6351C14.2819 58.0352 12.6879 54.9605 11.3991 51.818C8.95724 45.8494 7.40844 39.6774 7.79281 33.2001C8.23371 25.649 11.207 18.4144 15.3446 12.1406C16.4073 10.5354 17.5491 8.93023 18.804 7.42679C19.2562 7.4494 19.6745 7.40418 20.0815 7.30244C20.6241 7.16679 21.1215 6.9068 21.585 6.59029C21.8111 6.43203 22.0373 6.25116 22.2407 6.04769C22.4555 5.85552 22.659 5.65205 22.8512 5.42596C23.2356 4.9851 23.6087 4.51033 23.9365 4.02426C24.5922 3.0521 25.1575 2.04604 25.5644 1.28867C25.7679 0.904327 25.9375 0.587813 26.0393 0.373035C26.0958 0.259994 26.141 0.180865 26.1636 0.113041C26.1749 0.0339123 26.1862 0 26.1862 0C26.1862 0 26.1523 0 26.0958 0C26.028 0.0113041 25.9375 0.0226082 25.8132 0.0339123C25.5644 0.0678245 25.2027 0.135649 24.7731 0.237386C23.9139 0.44086 22.7608 0.825199 21.6416 1.43562C20.5337 2.04604 19.4597 2.87124 18.7927 3.88861C18.4535 4.38599 18.2161 4.93989 18.1144 5.5164C18.0239 5.99117 18.0465 6.49985 18.1709 7.03114C15.2542 10.5015 12.8349 14.4918 10.9695 18.4935C8.652 23.4447 7.26147 28.7915 7.04667 34.2514C6.80926 40.5252 8.51634 46.5389 10.8678 52.2927C12.7784 56.9274 15.4803 61.1325 19.3579 64.3542Z"
      fill={color}
    />
    <path
      d="M65.3132 75.7486C66.7489 75.5 68.0716 75.0478 69.0212 74.6295C69.9709 74.2226 70.57 73.8835 70.57 73.8835C70.57 73.8835 69.9596 73.6461 69.0325 73.3296C68.1055 73.0131 66.862 72.6174 65.5393 72.3009C64.2279 71.9844 62.8599 71.747 61.6051 71.8035C60.972 71.8261 60.3728 71.9392 59.7963 72.1426C59.2197 72.3574 58.6771 72.6739 58.0779 73.1148C58.4623 74.4261 59.6154 75.2513 60.9607 75.6356C62.3286 76.0313 63.8887 75.9973 65.3132 75.7486Z"
      fill={color}
    />
    <path
      d="M58.2587 71.0465C58.8352 70.9334 59.3778 70.6621 59.8638 70.3004C60.836 69.5656 61.5821 68.4465 62.0907 67.3048C62.5994 66.1631 62.882 64.9875 63.029 64.1058C63.0968 63.6649 63.142 63.3032 63.1646 63.0432C63.1872 62.7832 63.1872 62.6362 63.1872 62.6362C63.1872 62.6362 62.7351 62.8849 62.0681 63.2919C61.4012 63.7101 60.5195 64.2979 59.6604 64.9988C58.8013 65.6996 57.9648 66.5135 57.3769 67.4631C56.7891 68.4126 56.4161 69.4978 56.45 70.8656C57.0604 71.1369 57.6822 71.1595 58.2587 71.0465Z"
      fill={color}
    />
    <path
      d="M74.979 66.0382C73.6224 66.0834 72.2432 66.1739 71.0561 66.5356C69.8691 66.8973 68.8856 67.5304 68.2299 68.6947C69.0438 69.7912 70.2083 70.2999 71.5196 70.3564C72.831 70.4242 74.2781 70.0399 75.6121 69.4294C76.9461 68.8303 78.1557 68.0051 79.0036 67.3043C79.4332 66.9652 79.7724 66.6373 80.0098 66.4226C80.2472 66.1965 80.3715 66.0608 80.3715 66.0608C80.3715 66.0608 79.7159 66.0495 78.6871 66.0269C77.6696 66.0269 76.3243 66.0043 74.979 66.0382Z"
      fill={color}
    />
    <path
      d="M65.9463 66.6829C67.2349 66.7507 68.2749 66.129 69.021 65.1794C69.7671 64.2299 70.2079 62.9751 70.3888 61.743C70.5696 60.5108 70.5131 59.3352 70.3662 58.4761C70.2983 58.0465 70.2305 57.7074 70.1627 57.4587C70.0949 57.2213 70.061 57.0857 70.061 57.0857C70.061 57.0857 69.9818 57.1648 69.8462 57.3118C69.6992 57.4587 69.5071 57.6735 69.2697 57.9448C68.7949 58.4874 68.1393 59.2335 67.4949 60.1152C66.8619 60.9969 66.2289 62.003 65.8671 63.1108C65.5054 64.2299 65.415 65.4281 65.9463 66.6829Z"
      fill={color}
    />
    <path
      d="M83.7398 59.9568C83.8755 59.7985 84.0111 59.629 84.1355 59.4594L84.3276 59.2107L84.4746 59.0072C84.6668 58.7359 84.8476 58.4759 85.0172 58.2159C85.3563 57.696 85.6502 57.1986 85.8876 56.769C86.125 56.3395 86.3172 55.9777 86.4415 55.729C86.5659 55.469 86.6224 55.3108 86.6224 55.3108C86.6224 55.3108 86.0233 55.4917 85.085 55.7743C84.1581 56.0682 82.9485 56.4977 81.7616 57.0516C81.4677 57.1873 81.1738 57.3342 80.8799 57.4925C80.5634 57.6733 80.2695 57.8429 79.9756 58.0238C79.6817 58.2046 79.3878 58.3742 79.1165 58.5664C78.8452 58.7472 78.5739 58.9281 78.3252 59.1316C77.3304 59.9116 76.5956 60.8046 76.2904 62.1159C77.3869 62.9297 78.6643 63.0767 79.9869 62.6471C81.3095 62.2515 82.6546 61.2567 83.7398 59.9568Z"
      fill={color}
    />
    <path
      d="M75.8266 54.4745C75.4875 53.2536 74.9901 52.1571 74.5719 51.3771C74.3684 50.9815 74.1875 50.665 74.0406 50.4502C73.8936 50.2354 73.8145 50.1111 73.8145 50.1111C73.8145 50.1111 73.7693 50.2354 73.6902 50.4502C73.5997 50.665 73.4641 50.9702 73.3284 51.3545C73.1928 51.7389 73.0345 52.1797 72.8989 52.6884C72.7632 53.1745 72.6163 53.7962 72.571 54.1579C72.458 55.0284 72.3111 56.0683 72.3676 57.1648C72.4354 58.2613 72.718 59.4144 73.5771 60.4656C74.8206 60.1717 75.6345 59.2448 75.9849 58.1144C76.064 57.8318 76.1431 57.5379 76.1658 57.2327C76.1884 56.9275 76.1997 56.6222 76.1884 56.317C76.1658 56.0118 76.1205 55.7066 76.064 55.4127C75.9849 55.0962 75.9058 54.7797 75.8266 54.4745Z"
      fill={color}
    />
    <path
      d="M89.6071 44.9563C89.6749 44.6737 89.7088 44.5042 89.7088 44.5042C89.7088 44.5042 89.1549 44.7981 88.2845 45.2615C87.4254 45.7363 86.3063 46.3919 85.255 47.1493C84.1585 47.8954 83.0733 48.7432 82.3724 49.7266C82.2029 49.9753 82.022 50.2127 81.8751 50.4727C81.7281 50.7327 81.6151 50.9927 81.5246 51.2753C81.3551 51.8292 81.2986 52.4283 81.4116 53.084C82.7229 53.457 83.9211 53.1744 85.0063 52.4735C85.2776 52.304 85.5376 52.1005 85.7976 51.8857C86.0463 51.6709 86.3063 51.4336 86.521 51.1736C86.9619 50.6536 87.3688 50.0771 87.7306 49.4893C88.488 48.3249 88.9401 47.0476 89.2566 46.098C89.4149 45.6346 89.5279 45.2389 89.6071 44.9563Z"
      fill={color}
    />
    <path
      d="M78.2912 52.0102C78.8111 51.6484 79.1842 51.185 79.4442 50.6763C79.5685 50.4276 79.6702 50.145 79.7381 49.8737C79.8059 49.5911 79.8624 49.3085 79.8511 49.0033C79.8624 47.805 79.512 46.539 78.9807 45.4199C78.4155 44.2895 77.7259 43.3173 77.172 42.6391C76.8894 42.3 76.6634 42.0287 76.4712 41.8478C76.2903 41.6669 76.1773 41.5652 76.1773 41.5652C76.1773 41.5652 76.1434 41.6895 76.1095 41.9043C76.0642 42.1191 75.9964 42.4356 75.9286 42.8199C75.7816 43.5886 75.7138 44.6399 75.646 45.759C75.6234 46.3129 75.646 46.9007 75.7138 47.4885C75.7364 47.6355 75.759 47.7824 75.7816 47.9294C75.8042 48.0763 75.8156 48.212 75.8495 48.3589C75.906 48.6415 75.9738 48.9355 76.0642 49.2067C76.426 50.3032 77.1042 51.3206 78.2912 52.0102Z"
      fill={color}
    />
    <path
      d="M86.6909 36.7041C86.4648 36.9527 86.25 37.2014 86.0466 37.4501C85.8431 37.7101 85.6396 37.9588 85.4248 38.2188C85.0292 38.7388 84.6788 39.2814 84.4301 39.824C84.3057 40.0953 84.204 40.3779 84.1249 40.6605C84.0344 40.9431 83.9666 41.2257 83.9327 41.5083C83.8649 42.0848 83.9327 42.6726 84.1701 43.2943C85.5266 43.4187 86.657 42.8987 87.5839 41.9944C87.8213 41.7683 88.0361 41.5196 88.2509 41.2596C88.4543 40.9883 88.6239 40.7057 88.7935 40.4005C89.1213 39.7901 89.4039 39.1344 89.6526 38.4788C89.7769 38.151 89.8673 37.8119 89.9465 37.484C90.0256 37.1562 90.0934 36.8284 90.15 36.5119C90.263 35.8789 90.3647 35.291 90.4099 34.7711C90.4665 33.7537 90.4552 33.0754 90.4552 33.0754C90.4552 33.0754 89.9578 33.4937 89.2569 34.1606C88.5674 34.8389 87.5839 35.7319 86.6909 36.7041Z"
      fill={color}
    />
    <path
      d="M81.8069 41.0565C81.886 40.7852 81.9312 40.5026 81.9425 40.22C81.9538 39.9374 81.9086 39.6435 81.8521 39.3496C81.7391 38.7731 81.5356 38.1966 81.2643 37.6427C81.1965 37.507 81.1286 37.3714 81.0495 37.2357C80.9704 37.1001 80.88 36.9644 80.7895 36.8401C80.6087 36.5801 80.4165 36.3314 80.2243 36.0827C79.8287 35.6079 79.4217 35.1671 79.0261 34.7941C78.8339 34.6019 78.6304 34.4323 78.4157 34.2741C78.2122 34.1158 78.02 33.9689 77.8392 33.8445C77.127 33.3245 76.6183 33.0532 76.6183 33.0532C76.6183 33.0532 76.607 33.5393 76.6974 34.2854C76.72 34.4662 76.7314 34.6697 76.7427 34.8958C76.754 35.1106 76.7766 35.3366 76.8105 35.5853C76.8557 36.0601 76.9687 36.5801 77.0705 37.1114C77.1609 37.6427 77.2966 38.1966 77.4887 38.7279C77.5792 38.9992 77.6922 39.2592 77.8166 39.5305C77.9296 39.7905 78.0426 40.0505 78.1896 40.2991C78.7548 41.2826 79.6139 42.1417 80.9139 42.5939C81.3773 42.1304 81.6486 41.6104 81.8069 41.0565Z"
      fill={color}
    />
    <path
      d="M84.2266 29.7862C84.0909 30.374 84.0457 30.9506 84.1362 31.5271C84.1814 31.8097 84.2718 32.0923 84.3622 32.3636C84.464 32.6462 84.5883 32.9175 84.7692 33.1888C86.1144 32.9966 87.1543 32.2279 87.7987 31.1201C88.1265 30.5662 88.3865 29.9332 88.59 29.2662C88.7708 28.5993 88.8613 27.8871 88.9178 27.1863C88.9404 26.8359 88.963 26.4854 88.9743 26.135C88.963 25.7959 88.9517 25.4681 88.9178 25.1403C88.8726 24.4959 88.7934 23.8968 88.7256 23.3881C88.5221 22.3934 88.33 21.749 88.33 21.749C88.33 21.749 87.9569 22.2803 87.4483 23.1055C87.1996 23.5125 86.9057 23.9872 86.5778 24.5185C86.2613 25.0498 85.9335 25.615 85.6283 26.2028C85.3344 26.7793 85.0179 27.3898 84.7692 27.9889C84.5318 28.5993 84.3509 29.1984 84.2266 29.7862Z"
      fill={color}
    />
    <path
      d="M81.6484 29.6166C81.3998 29.0853 81.038 28.5879 80.6311 28.1244C80.4276 27.8983 80.2128 27.6723 79.9867 27.4688C79.7607 27.2653 79.5007 27.0731 79.2633 26.8923C78.2572 26.1688 77.2398 25.6601 76.392 25.3549C75.5668 25.0497 75.0129 24.9141 75.0129 24.9141C75.0129 24.9141 75.126 25.3775 75.3973 26.0671C75.5103 26.4175 75.646 26.8245 75.8268 27.2653C75.9173 27.4801 76.019 27.7062 76.1207 27.9436C76.2338 28.1696 76.3242 28.4183 76.4373 28.6557C76.6633 29.1305 76.9459 29.6166 77.2625 30.08C77.5564 30.5435 77.8955 30.9957 78.3024 31.3913C79.1389 32.1826 80.1224 32.8043 81.4789 32.94C81.6484 32.6687 81.7728 32.3974 81.8632 32.1261C81.9536 31.8435 81.9763 31.5722 81.9763 31.2896C81.9989 30.7131 81.8745 30.1479 81.6484 29.6166Z"
      fill={color}
    />
    <path
      d="M83.5029 11.4619C83.5029 11.4619 83.2769 12.0497 82.9603 12.9767C82.6438 13.9036 82.2821 15.1131 81.9543 16.4018C81.796 17.0461 81.683 17.6905 81.5812 18.3235C81.4795 18.9678 81.4343 19.6009 81.4795 20.1887C81.5134 20.4826 81.536 20.7765 81.5925 21.0591C81.6491 21.3417 81.7282 21.613 81.8412 21.873C81.9543 22.133 82.1012 22.3817 82.2821 22.6191C82.4517 22.8564 82.6438 23.0938 82.8812 23.3086C83.5142 23.0373 84.0229 22.6643 84.4186 22.1895C84.8255 21.7147 85.0855 21.1608 85.2777 20.5504C85.3681 20.2452 85.4359 19.9174 85.4925 19.5896C85.5377 19.2617 85.5829 18.9113 85.5716 18.5722C85.5716 17.8826 85.5038 17.1818 85.3907 16.4922C85.1194 15.1357 84.6786 13.8471 84.249 12.9427C84.0455 12.4906 83.8534 12.1176 83.729 11.8576C83.5934 11.6089 83.5029 11.4619 83.5029 11.4619Z"
      fill={color}
    />
    <path
      d="M79.4552 21.0597C79.3308 20.811 79.1839 20.5623 78.9804 20.3475C78.596 19.9067 78.1439 19.511 77.6465 19.1606C77.1378 18.8215 76.5613 18.5502 75.9961 18.3241C75.7135 18.2111 75.4309 18.1093 75.1483 18.0189C74.8657 17.9285 74.5831 17.8606 74.3118 17.8041C73.7692 17.6798 73.2605 17.6006 72.831 17.5441C72.4014 17.4876 72.051 17.465 71.791 17.4537C71.531 17.4424 71.384 17.4424 71.384 17.4424C71.384 17.4424 71.4406 17.5441 71.5649 17.7363C71.6779 17.9172 71.8249 18.1885 72.0397 18.4937C72.1414 18.6519 72.2544 18.8102 72.3901 18.991C72.4579 19.0702 72.5144 19.1719 72.5936 19.2623C72.6614 19.3528 72.7179 19.4432 72.7857 19.5449C73.057 19.9293 73.3849 20.3362 73.7466 20.7319C74.0857 21.1388 74.4587 21.5345 74.8883 21.8962C74.99 21.9866 75.1031 22.0771 75.2161 22.1675C75.3179 22.2579 75.4309 22.3371 75.5439 22.4275C75.7587 22.597 75.9961 22.7553 76.2448 22.891C76.7309 23.1736 77.2848 23.3883 77.85 23.5127C78.4152 23.637 79.0369 23.6709 79.7151 23.5579C79.8056 23.264 79.8621 22.9588 79.8847 22.6762C79.8847 22.3936 79.8508 22.111 79.783 21.8397C79.6812 21.5684 79.5795 21.3084 79.4552 21.0597Z"
      fill={color}
    />
    <path
      d="M78.6077 14.3109C79.6929 13.497 80.2016 12.3553 80.2807 11.0666C80.3147 10.4336 80.2355 9.76667 80.0999 9.09973C79.9529 8.43278 79.7155 7.78845 79.4555 7.14412C79.1842 6.51109 78.8564 5.93458 78.5512 5.39198C78.2347 4.84939 77.8956 4.38592 77.6017 3.99028C77.3191 3.60594 77.0478 3.28942 76.8669 3.07464C76.6747 2.85987 76.573 2.74683 76.573 2.74683C76.573 2.74683 76.4713 3.37986 76.3695 4.31809C76.313 4.79287 76.2565 5.35807 76.2113 5.95719C76.1887 6.25109 76.1661 6.56761 76.1548 6.88412C76.1434 7.20064 76.1208 7.52846 76.1208 7.85627C76.1095 9.15625 76.1661 10.5014 76.5165 11.6318C76.6747 12.2084 76.9234 12.7283 77.2739 13.1692C77.5904 13.6327 78.0312 14.017 78.6077 14.3109Z"
      fill={color}
    />
    <path
      d="M74.1417 12.0388C73.2148 11.3493 71.9826 10.931 70.7731 10.7502C70.174 10.6484 69.5748 10.6145 69.0096 10.6145C68.4557 10.6145 67.947 10.6371 67.5062 10.671C66.6245 10.7615 66.0593 10.8858 66.0593 10.8858C66.0593 10.8858 66.1384 10.9762 66.2966 11.1345C66.4436 11.2927 66.6697 11.5075 66.941 11.7788C67.2123 12.0501 67.5401 12.344 67.9018 12.6605C68.2636 12.9771 68.6705 13.3049 69.1114 13.6214C69.5409 13.9492 70.0157 14.2431 70.5131 14.5144C70.9992 14.7857 71.5191 15.0118 72.073 15.1701C73.1582 15.4866 74.3452 15.5318 75.5999 14.9892C75.6338 14.3675 75.4982 13.8023 75.2495 13.3049C74.9782 12.8188 74.5939 12.4005 74.1417 12.0388Z"
      fill={color}
    />
    <path
      d="M24.1451 32.7713V23.8185C24.1451 23.7371 24.1994 23.6828 24.2808 23.6828H28.3096C28.391 23.6828 28.4452 23.7371 28.4452 23.8185V25.1479C28.4452 25.2292 28.391 25.2835 28.3096 25.2835H26.0035C25.9493 25.2835 25.9221 25.3106 25.9221 25.3649V27.3725C25.9221 27.4268 25.9493 27.4539 26.0035 27.4539H27.9976C28.079 27.4539 28.1332 27.5081 28.1332 27.5895V28.9189C28.1332 29.0003 28.079 29.0545 27.9976 29.0545H26.0035C25.9493 29.0545 25.9221 29.0817 25.9221 29.1359V31.2249C25.9221 31.2792 25.9493 31.3063 26.0035 31.3063H28.3096C28.391 31.3063 28.4452 31.3606 28.4452 31.442V32.7713C28.4452 32.8527 28.391 32.907 28.3096 32.907H24.2808C24.1994 32.907 24.1451 32.8527 24.1451 32.7713ZM29.4307 32.7713V23.8185C29.4307 23.7371 29.4849 23.6828 29.5663 23.6828H31.0313C31.1534 23.6828 31.2212 23.7235 31.2484 23.8185L32.6591 28.6612H32.7134L34.0699 23.8185C34.097 23.7235 34.1648 23.6828 34.2869 23.6828H35.7384C35.8198 23.6828 35.874 23.7371 35.874 23.8185V32.7713C35.874 32.8527 35.8198 32.907 35.7384 32.907H34.4226C34.3412 32.907 34.2869 32.8527 34.2869 32.7713V27.4403H34.2055L33.2017 31.13C33.1746 31.2114 33.1203 31.2656 33.0254 31.2656H32.2793C32.1844 31.2656 32.1301 31.2114 32.103 31.13L31.0992 27.4403H31.0178V32.7713C31.0178 32.8527 30.9635 32.907 30.8821 32.907H29.5663C29.4849 32.907 29.4307 32.8527 29.4307 32.7713ZM38.7685 32.907H37.2628C37.1814 32.907 37.1272 32.8527 37.1272 32.7713V23.8185C37.1272 23.7371 37.1814 23.6828 37.2628 23.6828H39.4332C41.1153 23.6828 42.1462 24.4832 42.1462 26.5857C42.1462 28.6747 41.0746 29.4886 39.4332 29.4886H38.9856C38.9313 29.4886 38.9042 29.5158 38.9042 29.57V32.7713C38.9042 32.8527 38.8499 32.907 38.7685 32.907ZM39.3789 27.9287C40.0708 27.9287 40.3692 27.6302 40.3692 26.5857C40.3692 25.5412 40.0708 25.2428 39.3789 25.2428H38.9856C38.9313 25.2428 38.9042 25.2699 38.9042 25.3242V27.8473C38.9042 27.9015 38.9313 27.9287 38.9856 27.9287H39.3789ZM43.1413 32.7713V23.8185C43.1413 23.7371 43.1956 23.6828 43.2769 23.6828H44.7827C44.864 23.6828 44.9183 23.7371 44.9183 23.8185V31.2249C44.9183 31.2792 44.9454 31.3063 44.9997 31.3063H47.3329C47.4142 31.3063 47.4685 31.3606 47.4685 31.442V32.7713C47.4685 32.8527 47.4142 32.907 47.3329 32.907H43.2769C43.1956 32.907 43.1413 32.8527 43.1413 32.7713ZM50.444 33.0291C49.2367 33.0291 48.4228 32.4865 48.0837 31.4691C47.9345 31.0486 47.8938 30.6688 47.8938 28.2949C47.8938 25.9211 47.9345 25.5412 48.0837 25.1207C48.4228 24.1034 49.2367 23.5608 50.444 23.5608C51.6513 23.5608 52.4652 24.1034 52.8043 25.1207C52.9535 25.5412 52.9942 25.9211 52.9942 28.2949C52.9942 30.6688 52.9535 31.0486 52.8043 31.4691C52.4652 32.4865 51.6513 33.0291 50.444 33.0291ZM50.444 31.4284C50.7831 31.4284 51.0137 31.2385 51.0951 30.9808C51.1629 30.7637 51.1901 30.5331 51.1901 28.2949C51.1901 26.0567 51.1629 25.8261 51.0951 25.6091C51.0137 25.3513 50.7831 25.1614 50.444 25.1614C50.1049 25.1614 49.8743 25.3513 49.7929 25.6091C49.7251 25.8261 49.6979 26.0567 49.6979 28.2949C49.6979 30.5331 49.7251 30.7637 49.7929 30.9808C49.8743 31.2385 50.1049 31.4284 50.444 31.4284ZM56.6553 32.907H55.1496C55.0682 32.907 55.014 32.8527 55.014 32.7713V29.2445L53.2234 23.8185C53.1963 23.7371 53.2234 23.6828 53.3319 23.6828H54.8376C54.9326 23.6828 54.9869 23.7235 55.0004 23.8185L55.9093 27.1962H55.9635L56.8317 23.8185C56.8588 23.7235 56.8995 23.6828 56.9945 23.6828H58.473C58.5816 23.6828 58.6087 23.7371 58.5816 23.8185L56.791 29.2445V32.7713C56.791 32.8527 56.7367 32.907 56.6553 32.907ZM59.3159 32.7713V23.8185C59.3159 23.7371 59.3701 23.6828 59.4515 23.6828H63.4803C63.5617 23.6828 63.6159 23.7371 63.6159 23.8185V25.1479C63.6159 25.2292 63.5617 25.2835 63.4803 25.2835H61.1743C61.12 25.2835 61.0929 25.3106 61.0929 25.3649V27.3725C61.0929 27.4268 61.12 27.4539 61.1743 27.4539H63.1683C63.2497 27.4539 63.304 27.5081 63.304 27.5895V28.9189C63.304 29.0003 63.2497 29.0545 63.1683 29.0545H61.1743C61.12 29.0545 61.0929 29.0817 61.0929 29.1359V31.2249C61.0929 31.2792 61.12 31.3063 61.1743 31.3063H63.4803C63.5617 31.3063 63.6159 31.3606 63.6159 31.442V32.7713C63.6159 32.8527 63.5617 32.907 63.4803 32.907H59.4515C59.3701 32.907 59.3159 32.8527 59.3159 32.7713ZM64.6014 32.7713V23.8185C64.6014 23.7371 64.6557 23.6828 64.7371 23.6828H68.7658C68.8472 23.6828 68.9015 23.7371 68.9015 23.8185V25.1479C68.9015 25.2292 68.8472 25.2835 68.7658 25.2835H66.4598C66.4055 25.2835 66.3784 25.3106 66.3784 25.3649V27.3725C66.3784 27.4268 66.4055 27.4539 66.4598 27.4539H68.4538C68.5352 27.4539 68.5895 27.5081 68.5895 27.5895V28.9189C68.5895 29.0003 68.5352 29.0545 68.4538 29.0545H66.4598C66.4055 29.0545 66.3784 29.0817 66.3784 29.1359V31.2249C66.3784 31.2792 66.4055 31.3063 66.4598 31.3063H68.7658C68.8472 31.3063 68.9015 31.3606 68.9015 31.442V32.7713C68.9015 32.8527 68.8472 32.907 68.7658 32.907H64.7371C64.6557 32.907 64.6014 32.8527 64.6014 32.7713Z"
      fill={color}
    />
    <path
      d="M34.3041 45.7246C33.0969 45.7246 32.283 45.182 31.9438 44.1647C31.7946 43.7441 31.7539 43.3643 31.7539 40.9905C31.7539 38.6166 31.7946 38.2368 31.9438 37.8163C32.283 36.7989 33.0969 36.2563 34.3041 36.2563C35.5114 36.2563 36.3253 36.7989 36.6644 37.8163C36.8136 38.2368 36.8543 38.6166 36.8543 40.9905C36.8543 43.3643 36.8136 43.7441 36.6644 44.1647C36.3253 45.182 35.5114 45.7246 34.3041 45.7246ZM34.3041 44.124C34.6433 44.124 34.8739 43.9341 34.9552 43.6763C35.0231 43.4593 35.0502 43.2287 35.0502 40.9905C35.0502 38.7523 35.0231 38.5217 34.9552 38.3046C34.8739 38.0469 34.6433 37.857 34.3041 37.857C33.965 37.857 33.7344 38.0469 33.653 38.3046C33.5852 38.5217 33.5581 38.7523 33.5581 40.9905C33.5581 43.2287 33.5852 43.4593 33.653 43.6763C33.7344 43.9341 33.965 44.124 34.3041 44.124ZM37.9699 45.4669V36.5141C37.9699 36.4327 38.0242 36.3784 38.1056 36.3784H42.1344C42.2158 36.3784 42.27 36.4327 42.27 36.5141V37.8434C42.27 37.9248 42.2158 37.9791 42.1344 37.9791H39.8283C39.7741 37.9791 39.7469 38.0062 39.7469 38.0604V40.1494C39.7469 40.2037 39.7741 40.2308 39.8283 40.2308H41.8224C41.9038 40.2308 41.958 40.2851 41.958 40.3665V41.7094C41.958 41.7908 41.9038 41.8451 41.8224 41.8451H39.8283C39.7741 41.8451 39.7469 41.8722 39.7469 41.9264V45.4669C39.7469 45.5483 39.6927 45.6025 39.6113 45.6025H38.1056C38.0242 45.6025 37.9699 45.5483 37.9699 45.4669ZM48.5952 45.6025H47.0895C47.0081 45.6025 46.9538 45.5483 46.9538 45.4669V38.0604C46.9538 38.0062 46.9267 37.9791 46.8724 37.9791H45.421C45.3396 37.9791 45.2853 37.9248 45.2853 37.8434V36.5141C45.2853 36.4327 45.3396 36.3784 45.421 36.3784H50.2637C50.3451 36.3784 50.3993 36.4327 50.3993 36.5141V37.8434C50.3993 37.9248 50.3451 37.9791 50.2637 37.9791H48.8122C48.758 37.9791 48.7308 38.0062 48.7308 38.0604V45.4669C48.7308 45.5483 48.6766 45.6025 48.5952 45.6025ZM51.2169 45.4669V36.5141C51.2169 36.4327 51.2712 36.3784 51.3526 36.3784H52.8583C52.9397 36.3784 52.9939 36.4327 52.9939 36.5141V40.0138C52.9939 40.0681 53.0211 40.0952 53.0753 40.0952H54.364C54.4182 40.0952 54.4454 40.0681 54.4454 40.0138V36.5141C54.4454 36.4327 54.4996 36.3784 54.581 36.3784H56.0867C56.1681 36.3784 56.2224 36.4327 56.2224 36.5141V45.4669C56.2224 45.5483 56.1681 45.6025 56.0867 45.6025H54.581C54.4996 45.6025 54.4454 45.5483 54.4454 45.4669V41.7772C54.4454 41.723 54.4182 41.6958 54.364 41.6958H53.0753C53.0211 41.6958 52.9939 41.723 52.9939 41.7772V45.4669C52.9939 45.5483 52.9397 45.6025 52.8583 45.6025H51.3526C51.2712 45.6025 51.2169 45.5483 51.2169 45.4669ZM57.4695 45.4669V36.5141C57.4695 36.4327 57.5238 36.3784 57.6051 36.3784H61.6339C61.7153 36.3784 61.7696 36.4327 61.7696 36.5141V37.8434C61.7696 37.9248 61.7153 37.9791 61.6339 37.9791H59.3279C59.2736 37.9791 59.2465 38.0062 59.2465 38.0604V40.0681C59.2465 40.1223 59.2736 40.1494 59.3279 40.1494H61.3219C61.4033 40.1494 61.4576 40.2037 61.4576 40.2851V41.6145C61.4576 41.6958 61.4033 41.7501 61.3219 41.7501H59.3279C59.2736 41.7501 59.2465 41.7772 59.2465 41.8315V43.9205C59.2465 43.9748 59.2736 44.0019 59.3279 44.0019H61.6339C61.7153 44.0019 61.7696 44.0561 61.7696 44.1375V45.4669C61.7696 45.5483 61.7153 45.6025 61.6339 45.6025H57.6051C57.5238 45.6025 57.4695 45.5483 57.4695 45.4669Z"
      fill={color}
    />
    <path
      d="M38.4505 58.2976H36.9448C36.8634 58.2976 36.8091 58.2433 36.8091 58.162V54.6351L35.0186 49.2091C34.9914 49.1277 35.0186 49.0735 35.1271 49.0735H36.6328C36.7277 49.0735 36.782 49.1142 36.7956 49.2091L37.7044 52.5868H37.7587L38.6268 49.2091C38.6539 49.1142 38.6946 49.0735 38.7896 49.0735H40.2682C40.3767 49.0735 40.4038 49.1277 40.3767 49.2091L38.5861 54.6351V58.162C38.5861 58.2433 38.5319 58.2976 38.4505 58.2976ZM41.111 58.162V49.2091C41.111 49.1277 41.1653 49.0735 41.2466 49.0735H45.2754C45.3568 49.0735 45.4111 49.1277 45.4111 49.2091V50.5385C45.4111 50.6199 45.3568 50.6741 45.2754 50.6741H42.9694C42.9151 50.6741 42.888 50.7013 42.888 50.7555V52.7631C42.888 52.8174 42.9151 52.8445 42.9694 52.8445H44.9634C45.0448 52.8445 45.0991 52.8988 45.0991 52.9802V54.3095C45.0991 54.3909 45.0448 54.4452 44.9634 54.4452H42.9694C42.9151 54.4452 42.888 54.4723 42.888 54.5266V56.6156C42.888 56.6698 42.9151 56.6969 42.9694 56.6969H45.2754C45.3568 56.6969 45.4111 56.7512 45.4111 56.8326V58.162C45.4111 58.2433 45.3568 58.2976 45.2754 58.2976H41.2466C41.1653 58.2976 41.111 58.2433 41.111 58.162ZM45.8946 58.162L47.9023 49.2091C47.9294 49.1277 47.9701 49.0735 48.0515 49.0735H49.6521C49.7335 49.0735 49.7878 49.1277 49.8013 49.2091L51.7818 58.162C51.7954 58.2433 51.7547 58.2976 51.6733 58.2976H50.1676C50.0726 58.2976 50.0319 58.2433 50.0184 58.162L49.7199 56.4935H47.9701L47.6581 58.162C47.6445 58.2433 47.6038 58.2976 47.5089 58.2976H46.0032C45.9218 58.2976 45.8811 58.2433 45.8946 58.162ZM48.2278 55.0827H49.4622L48.8789 51.8814H48.8382L48.2278 55.0827ZM57.7253 58.2976H56.0975C56.0161 58.2976 55.9754 58.2705 55.9483 58.1891L54.9038 54.6893H54.3883C54.334 54.6893 54.3069 54.7165 54.3069 54.7707V58.162C54.3069 58.2433 54.2526 58.2976 54.1713 58.2976H52.6656C52.5842 58.2976 52.5299 58.2433 52.5299 58.162V49.2091C52.5299 49.1277 52.5842 49.0735 52.6656 49.0735H54.8631C56.5044 49.0735 57.5625 49.8467 57.5625 51.895C57.5625 53.0616 57.1691 53.8212 56.5316 54.2553L57.7931 58.162C57.8202 58.2298 57.7931 58.2976 57.7253 58.2976ZM54.7817 53.1565C55.4735 53.1565 55.7719 52.8716 55.7719 51.895C55.7719 50.9319 55.4735 50.6334 54.7817 50.6334H54.3883C54.334 50.6334 54.3069 50.6606 54.3069 50.7148V53.0751C54.3069 53.1294 54.334 53.1565 54.3883 53.1565H54.7817Z"
      fill={color}
    />
  </svg>
);
export const achievementsSvg = [SvgOne, SvgTwo];
export const fontAwesomeIcons = [
  "fa fa-plane",
  "fa fa-book",
  "fa fa-pencil",
  "fa fa-cutlery",
  "fa fa-leaf",
  "fa fa-soccer-ball-o",
  "fa fa-music",
  "fa fa-camera",
  "fa fa-paint-brush",
  "fa fa-handshake-o",
  "fa fa-tree",
  "fa fa-life-ring",
  "fa fa-gamepad",
  "fa fa-shopping-bag",
  "fa fa-film",
  "fa fa-laptop",
  "fa fa-wrench",
  "fa fa-scissors",
  "fa fa-circle-o",
  "fa fa-university",
  "fa fa-microphone",
  "fa fa-globe",
  "fa fa-music",
  "fa fa-bicycle",
  "fa fa-anchor",
  "fa fa-pencil",
  "fa fa-archive",
  "fa fa-cutlery",
  "fa fa-star",
  "fa fa-globe",
  "fa fa-hand-rock-o",
  "fa fa-users",
  "fa fa-pencil-square-o",
  "fa fa-binoculars",
  "fa fa-suitcase",
  "fa fa-trophy",
  "fa fa-life-ring",
  "fa fa-life-ring",
  "fa fa-gamepad",
  "fa fa-book",
  "fa fa-puzzle-piece",
  "fa fa-beer",
  "fa fa-paw",
  "fa fa-heartbeat",
  "fa fa-bullhorn",
  "fa fa-gavel",
  "fa fa-star",
  "fa fa-ticket",
  "fa fa-building-o",
  "fa fa-star",
  "fa fa-bolt",
  "fa fa-book",
  "fa fa-certificate",
  "fa fa-asterisk",
  "fa fa-address-book",
  "fa fa-anchor",
  "fa fa-bell",
  "fa fa-bookmark",
  "fa fa-check",
  "fa fa-check-circle",
  "fa fa-cog",
  "fa fa-diamond",
  "fa fa-envelope",
  "fa fa-heart",
  "fa fa-map-pin",
  "fa fa-pencil",
  "fa fa-paper-plane",
  "fa fa-plus",
  "fa fa-check-circle",
  "fa fa-refresh",
  "fa fa-bolt",
  "fa fa-exclamation-circle",
  "fa fa-trophy",
  "fa fa-thumbs-up",
  "fa fa-shield",
  "fa fa-paint-brush",
  "fa fa-search",
  "fa fa-list-ul",
  "fa fa-handshake-o",
  "fa fa-smile-o",
  "fa fa-balance-scale",
  "fa fa-arrows-h",
  "fa fa-arrow-right",
  "fa fa-heart",
  "fa fa-leaf",
  "fa fa-lightbulb-o",
  "fa fa-eye",
  "fa fa-check-square-o",
  "fa fa-magic",
  "fa fa-users",
  "fa fa-headphones",
  "fa fa-user-plus",
  "fa fa-star",
  "fa fa-handshake-o",
  "fa fa-globe",
  "fa fa-pencil",
  "fa fa-handshake-o",
  "fa fa-hourglass",
  "fa fa-road",
  "fa fa-calendar",
  "fa fa-sun-o",
  "fa fa-gavel",
  "fa fa-cogs",
  "fa fa-handshake-o",
  "fa fa-user-circle-o",
  "fa fa-lock",
  "fa fa-leaf",
  "fa fa-life-ring",
  "fa fa-heart-o",
  "fa fa-anchor",
  "fa fa-briefcase",
  "fa fa-group",
  "fa fa-chain",
  "fa fa-check",
  "fa fa-binoculars",
  "fa fa-thumbs-o-up",
  "fa fa-book",
  "fa fa-fire",

  "fa fa-lightbulb-o",
  "fa fa-smile-o",
  "fa fa-flag-checkered",
  "fa fa-rocket",
  "fa fa-check-circle",
  "fa fa-sun-o",
  "fa fa-shield",
];

export default masterData;
